<template>
  <div :style="initStyle(item)" class="p-a" @click="clickControl" v-if="!item.deleted"
    v-show="item.type=='proup'&&$store.state.showProupId==item.id||item.type!='proup'">
    <!-- 设备属性面板 -->
    <div class="deviceAttrBlock" v-if="item.DeviceAttrBlock&&item.DeviceAttrBlock.length" v-show="altDown"
      :style="{bottom:Number(item.height)+15+'px',left:(Number(item.width)-160)/2+'px'}">
      <div class="block-top">{{item.DeviceName}}</div>
      <div class="block-value" v-for="attr,a in item.DeviceAttrBlock" :key='a'>
        {{showBlockValue(attr)}}
      </div>
    </div>
    <!-- echarts图 -->
    <div class="echarts"
      :class="{'chart-bg-blue':item.controlId==33&&!item.warning,'chart-bg-red':item.controlId==33&&item.warning}"
      :ref="'graph'+item.id" :id="'graph'+item.id" v-if="item.type=='graph'&&item.controlId!=18&&item.controlId!=19"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px',backgroundColor:getRgba(item.bgColor,item.opacity)}">
    </div>
    <div class="echarts" v-if="item.controlId==18"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px',backgroundColor:getRgba(item.bgColor,item.opacity)}">
      <piegl :width='Number(item.width)' :height="Number(item.height)" :legend="item.legend"
        :legendTextShow="item.legendTextShow" :itemId="item.id" :ref="'pie3d'+item.id"></piegl>
    </div>
    <div class="pie" v-if="item.type=='graph'&&item.controlId==19"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px',backgroundColor:getRgba(item.bgColor,item.opacity)}">
      <!-- <div class="top">
        <div class="t-hide" v-for="title,t in item.attrList"><span class="dian"></span>{{title.name}} <span class="num">{{title.data?title.data[0]:''}}{{item.unit}}</span></div>
      </div> -->
      <div class="pie-chart" :ref="'graph'+item.id" :id="'graph'+item.id"></div>
    </div>
    <!-- 图片 -->
    <img :src="getImgUrl(item)" class="image" v-if="item.type=='image'">
    <img :src="getImgUrl2(item)" class="image" v-if="item.type=='control'">
    <!-- 矩形 -->
    <div class="rectangle" v-if="item.type=='rectangle'" :style="getStyle(item)">
    </div>
    <!-- 圆形 -->
    <div class="circular" v-if="item.type=='circular'" :style="getStyle(item)"></div>
    <!-- 直线 -->
    <div class="vline line" v-if="item.type=='vline'"
      :style="{backgroundColor:item.lineColor,width:item.lineWidth+'px'}"></div>
    <div class="hline line" v-if="item.type=='hline'"
      :style="{backgroundColor:item.lineColor,height:item.lineWidth+'px'}"></div>
    <!-- 管道 -->
    <div class="conduit" v-if="item.type=='conduit'"
      :style="{backgroundImage:'url(' + require('@/../static/indexEditorIcon/'+item.url) + ')'}">
      <div class="conduit-img" :class="{conduitX:item.width>item.height,xGif:item.direction==0}"
        :style="getConduitBg(item)"></div>
      <img :src="ConnectorUrl(item.FarLeft)" :class="'left'+item.FarLeft" v-if="item.FarLeft">
      <img :src="ConnectorUrl(item.NearRight)" :class="'right'+item.NearRight" v-if="item.NearRight">
      <img :src="ConnectorUrl(item.FarTop)" :class="'top'+item.FarTop" v-if="item.FarTop">
      <img :src="ConnectorUrl(item.NearBottom)" :class="'bottom'+item.NearBottom" v-if="item.NearBottom">
    </div>
    <!-- 动态面板 -->
    <div class="tabs" v-if="item.type=='panel'" :id="item.type+item.id"
      :style="{border:`${item.borderWidth}px solid ${item.borderColor}`,borderRadius:item.borderRadius+'px',backgroundColor:item.bgColor}">
      <div v-for="children,c in item.blockContentList" :key="c" class="panel-box" v-if="children.id==item.activeBlock">
        <controlItem ref="children" :item="drag" v-for="drag,d in children.drags" :key="d" v-if="!drag.deleted"
          :isCompany="isCompany" :altDown="altDown" @mqttUrl="emitMqtt" @showRoot="showRoot"
          @showDataBlock="showDataBlock"></controlItem>
      </div>
    </div>
    <!-- 文本标签 -->
    <span class="text-span" :id="'span'+item.id" v-if="item.type=='textSpan'" v-show="textSpanShow()"
      :style="{color:warningColor?'#fff':item.fontColor,fontSize:item.fontSize+'px',backgroundColor:warningColor?warningColor:getRgba(item.bgColor,item.opacity)}">
      <!-- 数据集 -->
      <span v-if="item.dataType==1">{{item.datasetId}}</span>
      <!-- 设备属性 -->
      <span v-else>{{getTextValue()}}</span>
      <span v-if="loadingShow"><i class="el-icon-loading" style="color: inherit;"></i></span>
    </span>
    <!-- 属性看板 -->
    <span class="attr-span" :id="'span'+item.id" v-if="item.type=='attrSpan'"
      :style="{color:item.fontColor,fontSize:item.fontSize+'px',backgroundColor:getRgba(item.bgColor,item.opacity)}"
      @click="showDataBlock(item)">{{item.controlName}}</span>
    <!-- 进度条 -->
    <div class="progress-bar" v-if="item.type=='progress'" :style="{opacity:item.opacity/100}">
      <div class="bar-title" v-if="item.textShow">
        <span
          :style="{color:item.titleColor,fontSize:item.titleSize+'px',lineHeight:item.titleSize+'px'}">{{item.controlName}}</span>
        <span class="f-r"
          :style="{color:item.numColor,fontSize:item.numSize+'px',lineHeight:item.titleSize+'px'}">{{getProgressVal(item,1)}}%</span>
      </div>
      <div class="bar-bg"
        :style="{width:item.barWidth+'px',height:item.barHeight+'px',marginTop:item.textShow?'14px':0,backgroundColor:getRgba(item.bgColor,item.opacity),borderWidth:item.borderWidth+'px',borderColor:item.borderColor,borderRadius:item.borderRadius+'px'}">
        <div class="bar" :style="getProgressVal(item,2)"></div>
        <div class="bar-line">
          <div v-for="i in Number(item.lineNum)+1" :key="i"
            :style="{width:100/(Number(item.lineNum)+1 )+ '%',borderLeftColor:item.lineColor,borderLeftWidth:item.lineWidth+'px'}">
          </div>
        </div>
      </div>
    </div>
    <!-- 横向柱状图 -->
    <div class="ranking-box" v-if="item.type=='ranking'"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,opacity:item.opacity/100,borderRadius:item.borderRadius+'px',backgroundColor:item.bgColor}">
      <transition-group name="list-complete" tag="div">
        <div v-for="bar,i in items" :key="bar.id" class="list-complete-item" :class="{'blue':true,'yellow':false}">
          <div class="top clearfix" :style="{fontSize:item.fontSize+'px'}">
            <div class="f-l" :title="bar.name"><span class="ranking">TOP{{i+1}}</span> <span
                class="name">{{bar.name}}</span></div>
            <div class="f-r" :title="bar.realityData"><span class="num">{{bar.realityData=="-"||!bar.realityData&&bar.realityData!=0?'-':bar.realityData.toFixed(item.decimal)}}</span>
            </div>
          </div>
          <div class="slider">
            <div class="slider-bar" :style="{backgroundColor:item.barColor,width:bar.barWidth + '%'}">
              <span class="spot"
                :style="[{backgroundColor:item.barColor},{boxShadow:`0 0 5px 2px ${item.barColor}`}]"></span>
              <!-- <img src="@/assets/editor-icon/blue-spot.png" class="spot"> -->
              <!-- <img v-if="item.realityData>70" src="@/assets/editor-icon/yellow-spot.png" class="spot"> -->
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <!-- 日历 -->
    <div class="calendar-box" v-if="item.type=='calendar'&&calendarShow"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px'}">
      <div class="calendar-top"
        :style="{backgroundColor:getRgba(item.bgColor,item.opacity),color:item.fontColor,fontSize:item.fontSize+'px'}">
        <div :title="item.controlName" class="calendar-name">{{item.controlName}}</div>
        <div class="data-box">
          <span style="margin-right: 20px;" class="data-span"
            :title="item.attrList[0].legendText||item.attrList[0].name||'-'">1：{{item.attrList[0].legendText||item.attrList[0].name||"-"}}</span>
          <span class="data-span" :title="item.attrList[1].legendText||item.attrList[1].name||'-'">2：{{item.attrList[1].legendText||item.attrList[1].name||"-"}}</span>
        </div>
      </div>
      <el-calendar v-model="calendarValue"
        :style="{backgroundColor:getRgba(item.bgColor,item.opacity),color:item.fontColor,fontSize:item.fontSize+'px'}">
        <!-- :range="currentMonthRange" :first-day-of-week="1" -->
        <template slot="dateCell" slot-scope="{date, data}">
          <p class="calendar-day">{{data.day.split('-').slice(2).toString()}}</p>
          <p class="t-hide calendar-data" :title="getCalendarText(date,data,0)" :style="getCalenderColor(date,data,0)"
            v-if="data.type=='current-month'">1：{{getCalendarText(date,data,0)}}</p>
          <p class="t-hide calendar-data" :title="getCalendarText(date,data,1)" :style="getCalenderColor(date,data,1)"
            v-if="data.type=='current-month'">2：{{getCalendarText(date,data,1)}}</p>
        </template>
      </el-calendar>
    </div>
    <!-- 横向等级图 -->
    <div class="grade-box" v-if="item.type=='gradeH'"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px'}">
      <i class="el-icon-location grade-icon"
        :style="{left:item.gradeValue>97?'98%':item.gradeValue?item.gradeValue+'%':'0%'}"></i>
      <div class="grade-bar" :style="{color:item.fontColor,fontSize:item.fontSize+'px'}">
        <div class="grade-bar-item radio-left" :class="{'grade-line':item.legend}"
          :style="{backgroundColor:item.color1,width:getWidth(1)}">{{item.text1}}</div>
        <div class="grade-bar-item" :class="{'grade-line':item.legend}" :style="{backgroundColor:item.color2,width:getWidth(2)}">{{item.text2}}</div>
        <div class="grade-bar-item" :class="{'grade-line':item.legend}" :style="{backgroundColor:item.color3,width:getWidth(3)}">{{item.text3}}</div>
        <div class="grade-bar-item radio-right" :style="{backgroundColor:item.color4,width:getWidth(4)}">{{item.text4}}</div>
      </div>
      <div class="grade-data-box" v-show="item.legend" :style="{fontSize:item.legendSize+'px', color: item.legendColor}">
        <div class="grade-data-item" :style="{left:getPosition(1)}">{{item.range1}}</div>
        <div class="grade-data-item" :style="{left:getPosition(2)}">{{item.range2}}</div>
        <div class="grade-data-item" :style="{left:getPosition(3)}">{{item.range3}}</div>
      </div>
    </div>
    <!-- 时间控件 -->
    <div class="time-box" v-if="item.type=='time'">
      <div class="time"
        :style="{color:item.timeColor,fontSize:item.timeSize+'px',lineHeight:Number(item.timeSize) + 4 + 'px'}">
        {{getTime(time)}}
      </div>
      <div class="day"
        :style="{color:item.dateColor,fontSize:item.dateSize+'px',lineHeight:Number(item.dateSize) + 4 + 'px'}">
        <p>{{getDate(time)}}</p>
        <p>{{getDay(time)}}</p>
      </div>
    </div>
    <!-- 时间控件 图表专用-->
    <div class="time-select clearfix" v-if="item.controlId==30">
      <div class="type-box" :style="{backgroundColor:item.bgColor,borderColor:item.borderColor}">
        <div :class="{'active':item.dateType == 2}" @click="setDateType(2)"
          :style="{color:item.dateType==2?item.activedFontColor:item.fontColor,backgroundColor:item.dateType==2?item.activedBgColor:''}">
          <span :style="{fontSize:item.fontSize+'px'}">时</span>
        </div>
        <div :class="{'active':item.dateType == 3}" @click="setDateType(3)"
          :style="{color:item.dateType==3?item.activedFontColor:item.fontColor,backgroundColor:item.dateType==3?item.activedBgColor:''}">
          <span :style="{fontSize:item.fontSize+'px'}">日</span>
        </div>
        <div :class="{'active':item.dateType == 5}" @click="setDateType(5)"
          :style="{color:item.dateType==5?item.activedFontColor:item.fontColor,backgroundColor:item.dateType==5?item.activedBgColor:''}">
          <span :style="{fontSize:item.fontSize+'px'}">月</span>
        </div>
        <div :class="{'active':item.dateType == 7}" @click="setDateType(7)"
          :style="{color:item.dateType==7?item.activedFontColor:item.fontColor,backgroundColor:item.dateType==7?item.activedBgColor:''}">
          <span :style="{fontSize:item.fontSize+'px'}">年</span>
        </div>
      </div>
      <!-- 微信端禁用时间控件输入 -->
      <div class="picker" @click="timepickShow"
        :style="{backgroundColor:item.bgColor,color:item.fontColor,borderColor:item.borderColor}">
        <el-date-picker v-model="item.timeVal" :editable="$store.state.openId?false:true" type="datetime"
          popper-class="hourpick" value-format="timestamp" :picker-options="pickerOptionsStart" placeholder="选择小时"
          :ref="'hourpick'+item.id" @change="changeDate" v-show="item.dateType==2">
        </el-date-picker>
        <el-date-picker v-model="item.timeVal" :editable="$store.state.openId?false:true" type="date"
          value-format="timestamp" :picker-options="pickerOptionsStart" placeholder="选择日期" :ref="'datepick'+item.id"
          @change="changeDate" v-show="item.dateType==3">
        </el-date-picker>
        <el-date-picker v-model="item.timeVal" :editable="$store.state.openId?false:true" type="month"
          value-format="timestamp" :picker-options="pickerOptionsStart" placeholder="选择月份" :ref="'monthpick'+item.id"
          @change="changeDate" v-show="item.dateType==5">
        </el-date-picker>
        <el-date-picker v-model="item.timeVal" :editable="$store.state.openId?false:true" type="year"
          value-format="timestamp" :picker-options="pickerOptionsStart" placeholder="选择年份" :ref="'yearpick'+item.id"
          @change="changeDate" v-show="item.dateType==7">
        </el-date-picker>
      </div>
    </div>
    <!-- <div v-if="item.controlId==30" style="color:#fff; font-size: 16px;">{{item.timeVal}}</div> -->
    <!-- 表格 -->
    <div class="table-box" v-if="item.type=='list'"
      :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px',backgroundColor:getRgba(item.bgColor,item.opacity)}">
      <div class="table-title"
        :style="{backgroundColor:!item.opacity?'transparent':`${getRgba(item.fgColor||'#2a2a2a',item.opacity)}`,fontSize:item.titleSize+'px',color:item.titleColor}">
        <!-- ,color:item.fontColor,fontSize:item.fontSize+'px' -->
        <div class="time">报警时间</div>
        <div class="type">报警分类</div>
        <div class="name">报警名</div>
        <div class="status">状态</div>
      </div>
      <div class="table-item" v-for="itemA,i in listData" :key="i"
        :style="{backgroundColor:!item.opacity?'transparent':`${getRgba(item.fgColor||'#2a2a2a',item.opacity)}`,fontSize:item.bodySize+'px',color:item.bodyColor}">
        <!-- ,color:item.fontColor,fontSize:item.fontSize+'px' -->
        <div class="time" :title="changeTime(itemA.updatedTime)">{{changeTime(itemA.updatedTime)}}</div>
        <div class="type" :title='itemA.ruleType==1?"产品报警":"设备报警"'>{{itemA.ruleType==1?"产品报警":"设备报警"}}</div>
        <div class="name" :title="itemA.name">{{itemA.name}}</div>
        <div class="status" :class="{'color-red':itemA.state==2}" :title="itemA.state==1?'已恢复':itemA.state==2?'存续':'手动恢复'">
          {{itemA.state==1?'已恢复':itemA.state==2?'存续':'手动恢复'}}
        </div>
      </div>
    </div>
    <!-- 报表表格 -->
    <div class="table-box" v-if="item.type=='table'">
      <div class="table-mask" :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px'}">
        <el-table
          :data="tableData"
          height="100%"
          border
          fit
          :style="{'width':'100%','background-color':getRgba(item.bodyBgColor,item.opacity)}"
          :header-row-class-name="'tableHeader'+item.id"
          :header-row-style="{
            fontSize:item.titleSize+'px',
            color:item.titleColor,
            backgroundColor:getRgba(item.titleBgColor,item.opacity)
          }"
          :row-style="{
            fontSize:item.bodySize+'px',
            color:item.bodyColor,
            backgroundColor:getRgba(item.bodyBgColor,item.opacity)
          }">
          <el-table-column
              type="index"
              width="60"
              label="序号">
          </el-table-column>
          <el-table-column
            prop="attrname"
            label="属性名">
          </el-table-column>
          <el-table-column
            prop="start"
            label="期初表码">
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="期初表码时间">
          </el-table-column>
          <el-table-column
            prop="end"
            label="期末表码">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="期末表码时间">
          </el-table-column>
          <el-table-column
            prop="val"
            label="用量">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 导航菜单 -->
    <div class="navmenu-box" v-if="item.type=='navmenu'" :style="{border:`${item.borderWidth}px solid ${getRgba(item.borderColor,item.opacity)}`,borderRadius:item.borderRadius+'px',backgroundColor:getRgba(item.bgColor,item.opacity)}">
      <el-menu @select="changeBlock" :unique-opened="true" :mode="item.vertical==true?'vertical':'horizontal'" :text-color="item.fontColor" :active-text-color="item.activedFontColor"  :background-color="getRgba(item.bgColor,item.opacity)">
        <menuItem :fontSize="item.fontSize" :fontColor="item.fontColor" :opacity="item.opacity" :activedBgColor="item.activedBgColor" :activeOpacity="item.activeOpacity" :menuData="navMenuData" :isTop='true'></menuItem>
      </el-menu>
    </div>
    <!-- 组合 -->
    <div class="makeUp" v-if="item.type=='makeUp'" :data-w="item.width-6" :data-h="item.height-6">
      <controlItem ref="children" :item="children" v-for="children,c in item.children" :key="c" v-if="!children.deleted"
        :isCompany="isCompany" :altDown="altDown" @mqttUrl="emitMqtt" @showDataBlock="showDataBlock"
        @showRoot="showRoot"></controlItem>
    </div>
    <!-- 弹窗 -->
    <div class="proup" v-if="item.type=='proup'" v-show="$store.state.showProupId==item.id" :data-w="item.width-6"
      :data-h="item.height-6"
      :style="{border:`${item.borderWidth}px solid ${item.borderColor}`,borderRadius:item.borderRadius+'px',backgroundColor:item.bgColor}">
      <controlItem ref="children" :item="children" v-for="children,c in item.children" :key="c" v-if="!children.deleted"
        :isCompany="isCompany" :altDown="altDown" @mqttUrl="emitMqtt" @showDataBlock="showDataBlock"
        @showRoot="showRoot"></controlItem>
      <i class="el-icon-error close-icon" @click="$store.state.showProupId=null"></i>
    </div>

    <deviceMap v-if="item.type=='deviceMap-3d'" :hideMask="true" @changePanelBlock="changePanelBlock"></deviceMap>
  </div>
</template>
<script>
  import {
    ChartsControlConfigList,
    ConnectorList,
    chartsColorOptions
  } from "../config/control.js"
  import {
    JSONParse,
    unzip
  } from "../config/functions.js"
  import piegl from './pie3d'
  import menuItem from "../Editor/menuItem"
  import deviceMap from '../screen-3d/screen-3d.vue'
  export default {
    name: "controlItem",
    data() {
      return {
        ConnectorList: ConnectorList,
        items: [],
        timer: 0,
        time: null,
        warningColor: "",
        attrList: [{}, {}],
        navMenuData:[],
        calendarShow: false,
        loadingShow: false,
        listData: [],
        textValue: null,
        calendarValue: new Date(),
        pickerOptionsStart: {
          disabledDate: (time) => {
            return time.getTime() >= Date.now();
            // if (this.dateType != 7) {
            //   return time.getTime() >= Date.now();
            // } else {
            //   return time.getFullYear() >= new Date().getFullYear()+1
            // }
          }
        },
        deviceList: [],
        tableData:[]
      }
    },
    components: {
      piegl,menuItem,deviceMap
    },
    props: {
      item: {
        default: {},
        type: Object
      },
      isCompany: {
        default: false,
        type: Boolean
      },
      altDown: {
        default: false,
        type: Boolean
      },
    },
    created() {
      if(!this.item.deleted){
        if (this.item.type == 'time') {
          this.time = new Date()
          let timeI = setInterval(() => {
            this.time = new Date()
          }, 1000)
        } else if (this.item.companyId == 36) {
          this.item.calendarValue = this.calendarValue
        }
        if(this.item.type=='navmenu'){
          this.navMenuData=this.DragList.filter(item=>item.type=='panel'&&!item.deleted)
        }
      }
      // if(this.item.type=="chartTime"){
      //   if(this.item.dateType==2){
      //     let now = new Date(),
      //         nowY = now.getFullYear(),
      //         nowM = now.getMonth()+1,
      //         nowD = now.getDate(),
      //         nowH = now.getHours()
      //     this.item.timeVal = new Date(`${nowY}/${nowM}/${nowD} ${nowH}:00:00`).getTime()

      //   }else if(this.item.dateType==3){
      //     let now = new Date(),
      //         nowY = now.getFullYear(),
      //         nowM = now.getMonth()+1,
      //         nowD = now.getDate()
      //     this.$set(this.item, "timeVal", new Date(`${nowY}/${nowM}/${nowD} 00:00:00`).getTime())

      //   }else if(this.item.dateType==5){
      //       let now = new Date(),
      //           nowY = now.getFullYear(),
      //           nowM = now.getMonth()+1
      //       this.$set(this.item, "timeVal", new Date(`${nowY}/${nowM}/1 00:00:00`).getTime())

      //   }else if(this.item.dateType==7){
      //       let now = new Date(),
      //           nowY = now.getFullYear()
      //       this.$set(this.item, "timeVal", new Date(`${nowY}/1/1 00:00:00`).getTime())
      //   }
      // }
    },
    async mounted() {
      if (!this.item.deleted) {
        // 图表处理
        if (this.item.type == 'graph' || this.item.type == "ranking" || this.item.type == "gradeH") {
          // console.log(this.item.isChartsTime,this.item.chartsTimeId)
          // 关联时间选择器则使用时间选择器的时间参数
          // if(this.item.type=='ranking'){
          await this.getDeviceList()
          // }
          if (this.item.isChartsTime && this.item.chartsTimeId) {
            this.resetTime()
          } else {
            this.initCharts(true)
            var timer = setTimeout(() => {
              this.initCharts(true)
              let time = 5000
              if (this.item.rate && this.item.rate != '0') {
                time = Number(this.item.rate) * 60 * 1000
              } else if (this.item.rate == 0) {
                switch (this.item.granularityUint) {
                  case 0:
                    time = this.item.granularity <= 5 ? 5000 : this.item.granularity * 1000
                    break;
                  case 1:
                    time = this.item.granularity * 1000 * 60
                    break;
                  case 2:
                    time = this.item.granularity * 1000 * 60 * 60
                    break;
                  case 3:
                    time = this.item.granularity * 1000 * 60 * 60 * 24
                    break;
                  case 5:
                    time = this.item.granularity * 1000 * 60 * 60 * 24 * 30
                    break;
                  case 7:
                    time = this.item.granularity * 1000 * 60 * 60 * 24 * 365
                    break;
                }
              }
              this.timer = setInterval(() => {
                this.initCharts(false)
              }, time)
              clearTimeout(timer)
            }, 1500)
          }
          // this.$nextTick(()=>{
          //   let dom = document.getElementById("graph"+this.item.id)
          //   dom.removeAttribute('_echarts_instance_')
          //   let echart = this.$echarts.init(dom)
          //   // console.log(drag)
          //   echart.setOption(this.item.options)
          // })
        } else if (this.item.type == 'list') { //报警列表处理
          this.getList()
          let time = 5000
          if (this.item.rate && this.item.rate != '0') {
            time = Number(this.item.rate) * 60 * 1000
          }
          this.timer = setInterval(() => {
            this.getList()
          }, time)
          this.getDeviceList()
        } else if (this.item.type == 'calendar') {
          if (!this.isCompany) {
            let ids = []
            for (let attr of this.item.attrList) {
              if (!ids.includes(attr.companyId)) {
                ids.push(attr.companyId)
                await this.getDeviceList(attr.companyId)
              }
            }
            this.getCalendarData()
          } else {
            await this.getDeviceList()
            this.getCalendarData()
          }
        } else if (this.item.type == 'textSpan' && this.item.isChartsTime && this.item.DeviceAttr) {
          this.resetTextTime()
        } else {
          // let time = 5000
          // if(this.item.rate){
          //   time = this.item.rate * 60 * 1000
          // }
          // this.timer = setInterval(()=>{
          //   this.getData()
          // } ,time)
          // this.getData()
        }
      }
    },
    beforeDestroy() {
      /* 清除定时器*/
      if (this.timer) {
        clearInterval(this.timer)
        // console.log("clearInterval")
        this.timer = null
      }
    },
    computed: {
      getWidth(){
        return (index)=>{
          var min = Number(this.item.min)||0
          var max = Number(this.item.max)||100
          var range = max - min
          if(index==1){
            var range = Math.round((Number(this.item.range1)-min)/range * 100)||25
            return range+"%"
          }else if(index==2){
            var range1 = Math.round((Number(this.item.range1)-min)/range * 100)||25
            var range2 = Math.round((Number(this.item.range2)-min)/range * 100)||50
            return range2 - range1 + "%"
          }else if(index==3){
            var range2 = Math.round((Number(this.item.range2)-min)/range * 100)||50
            var range3 = Math.round((Number(this.item.range3)-min)/range * 100)||75
            return range3 - range2 + "%"
          }else {
            var range3 = Math.round((Number(this.item.range3)-min)/range * 100)||75
            return 100 - range3 + "%"
          }
        }
      },
      getPosition(){
        return (index)=>{
          var min = Number(this.item.min)||0
          var max = Number(this.item.max)||100
          var range = max - min
          if(index==1){
            var range = Math.round((Number(this.item.range1)-min)/range * 100)||25
            return range -3 +"%"
          }else if(index==2){
            var range2 = Math.round((Number(this.item.range2)-min)/range * 100)||50
            return range2 - 3 + "%"
          }else if(index==3){
            var range3 = Math.round((Number(this.item.range3)-min)/range * 100)||75
            return range3 - 3 + "%"
          }
        }
      },
      getCalenderColor() {
        return (date, data, index) => {
          if (!this.attrList[index].dataArr) {
            return {}
          }
          let time = new Date(data.day + " 0:0:0").getTime()
          let data2 = this.attrList[index].dataArr.find(obj => obj.time == time)
          if (data2 && data2.warningColor) {
            return {
              backgroundColor: data2.warningColor,
              color: "#fff !important"
            }
          } else {
            return {}
          }
        }
      },
      getCalendarText() {
        return (date, data, index) => {
          if (!this.attrList[index].dataArr) {
            return '-'
          }
          let time = new Date(data.day + " 0:0:0").getTime()
          let data2 = this.attrList[index].dataArr.find(obj => obj.time == time)
          let attr = this.attrList[index]
          if (data2 && data2.value && (data2.value[0] || data2.value[0] == 0)) {
            let value = data2.value[0],
              decimal = this.item.decimal
            if (decimal == 0 || decimal) { //优先使用全局的小数保留值
              return value.toFixed(decimal)
            } else if (attr.step) {
              var decimalIndex = attr.step.indexOf('.');
              if (decimalIndex == -1) {
                return value.toFixed(0)
              } else {
                return value.toFixed(attr.step.length - decimalIndex - 1)
              }
            }
          } else {
            return '-'
          }
        }
      },
      showBlockValue() {
        return (code) => {
          let companyId = this.isCompany ? this.$store.state.companyId : this.item.companyId
          for (let company of this.indexPreviewData) {
            if (company.companyId == companyId && company.deviceList && this.item.DeviceCode) {
              let device = company.deviceList.find(item => item.code == this.item.DeviceCode)
              if (device && device.valueList && device.attrDataList) {
                let value = device.valueList.find(item => item.code == code)
                let attrData = device.attrDataList.find(item => item.code == code)
                if (attrData && (attrData.type == "bool" || attrData.type == "enum") && value) {
                  value = attrData.dataType.specs[Number(value.value)]
                  let name = attrData ? attrData.name : ''
                  return name + ": " + value
                } else if (attrData && value) {
                  let step = attrData.step || attrData.dataType.specs.step,
                    value2 = value.value
                  value2 = this.common.fmoney(value2, step)
                  let unit = attrData && attrData.unit ? attrData.unit : ''
                  value = value2 + unit
                  let name = attrData ? attrData.name : ''
                  return name + ": " + value
                }
              }
            }
          }
          return ''
        }
      },
      getRgba() {
        return (rgb, a) => {
          if (rgb == '#fff') {
            rgb = '#ffffff'
          }
          if (rgb == 'transparent' || a == 100) {
            return rgb
          } else if (a == 0) {
            return 'transparent'
          } else {
            a = parseInt(a * 2.55)
            a = a.toString(16)
            return rgb + a
          }
        }
      },
      // 获取设备名
      getDeviceName() {
        return (id) => {
          if (id || id == 0) {
            for (let item of this.deviceList) {
              if (item.id == id) {
                return item.name
              }
            }
          }
          return ''
        }
      },
      // 是否显示文本
      textSpanShow() {
        return () => {
          if (this.item.ShowAttrCode && this.item.ShowAttrCode.length && this.item.spanShowValue) {
            let show = false,companyId = this.isCompany ? this.$store.state.companyId : this.item.companyId
            for (let company of this.indexPreviewData) {
              if (company.companyId == companyId && company.deviceList && this.item.ShowAttrCode) {
                let device = company.deviceList.find(item => item.code == this.item.ShowAttrCode[0])
                if (device && device.valueList && device.attrDataList) {
                  let value = device.valueList.find(item => item.code == this.item.ShowAttrCode[1])
                  if (value && value.value == this.item.ShowAttrKey) {
                    show = true
                  }
                }
              }
            }
            return show
          } else {
            return true
          }
        }
      },
      // 显示属性值
      getTextValue() {
        return () => {
          if (this.item.spanShowValue) {
            let companyId = this.isCompany ? this.$store.state.companyId : this.item.companyId
            for (let company of this.indexPreviewData) {
              if (company.companyId == companyId && company.deviceList && this.item.DeviceAttr) {
                let device = company.deviceList.find(item => item.code == this.item.DeviceAttr[0])
                if (device && device.valueList && device.attrDataList) {
                  let value = this.textValue || device.valueList.find(item => item.code == this.item.DeviceAttr[1])
                  let attrData = device.attrDataList.find(item => item.code == this.item.DeviceAttr[1])
                  if (attrData && (attrData.type == "bool" || attrData.type == "enum") && value) {
                    value = attrData.dataType.specs[Number(value.value)]
                    if (this.item.ShowAttrName) {
                      let name = attrData ? attrData.name : ''
                      return name + ":" + value
                    }
                    return value
                  } else if (attrData && value) {
                    if (attrData.dataType && (attrData.dataType.errorDown || attrData.dataType.errorUp || attrData
                        .dataType.warnDown || attrData.dataType.warnUp)) {
                      let value1 = Number(value.value),
                        warningColor = ""
                      if (attrData.dataType.warnUp) {
                        if (value1 >= Number(attrData.dataType.warnUp)) {
                          warningColor = '#ff7e00'
                        }
                      }
                      if (attrData.dataType.warnDown) {
                        if (value1 <= Number(attrData.dataType.warnDown)) {
                          warningColor = '#ff7e00'
                        }
                      }
                      if (attrData.dataType.errorUp) {
                        if (value1 >= Number(attrData.dataType.errorUp)) {
                          warningColor = '#ff0000'
                        }
                      }
                      if (attrData.dataType.errorDown) {
                        if (value1 <= Number(attrData.dataType.errorDown)) {
                          warningColor = '#ff0000'
                        }
                      }
                      this.warningColor = warningColor
                    }
                    let step = attrData.step || attrData.dataType.specs.step,
                      value2 = value.value
                    if (typeof step == "number") {
                      step = step.toString()
                    }
                    if (typeof value2 == "string") {
                      value2 = value2.replace(/,/g, "");
                    }
                    // console.log(step)
                    var decimalIndex = step.indexOf('.');
                    if (decimalIndex == -1) {
                      value2 = Number(value2).toFixed(0)
                    } else {
                      value2 = Number(value2).toFixed(step.length - decimalIndex - 1)
                    }
                    value2 = this.common.fmoney(value2, step)
                    let unit = attrData && attrData.unit ? attrData.unit : ''
                    value = value2 + unit
                    if (this.item.ShowAttrName) {
                      let name = attrData ? attrData.name : ''
                      return name + ":" + value
                    }
                    return value
                  }
                }
              }
            }
          }
          return this.item.controlName
        }
      },
      // 圆形 矩形样式
      getStyle() {
        return (item, type) => {
          let companyId = this.item.companyId || this.$store.state.companyId
          let company = this.indexPreviewData.find(item => item.companyId == companyId)
          if (company && company.deviceList && item.colorAttr && item.colorList) {
            let device = company.deviceList.find(item => item.code == this.item.colorAttr[0])
            if (device && device.valueList && device.attrDataList) {
              let colorValue = device.valueList.find(item => item.code == this.item.colorAttr[1])
              if (colorValue) {
                colorValue = Number(colorValue.value)
                let color = this.getRgba(item.bgColor, item.opacity)
                for (let obj of item.colorList) {
                  if (obj.compare == 1) {
                    // >
                    if (colorValue > obj.compareVal) {
                      color = obj.color
                    }
                  } else if (obj.compare == 2) {
                    // >=
                    if (colorValue >= obj.compareVal) {
                      color = obj.color
                    }
                  } else if (obj.compare == 3) {
                    // ==
                    if (colorValue == obj.compareVal) {
                      color = obj.color
                    }
                  } else if (obj.compare == 4) {
                    // <
                    if (colorValue < obj.compareVal) {
                      color = obj.color
                    }
                  } else if (obj.compare == 5) {
                    // <=
                    if (colorValue <= obj.compareVal) {
                      color = obj.color
                    }
                  } else if (obj.compare == 6) {
                    // !=
                    if (colorValue != obj.compareVal) {
                      color = obj.color
                    }
                  } else if (obj.compare == 7) {
                    //in
                    let arr = JSON.parse(obj.compareVal);
                    if (arr.filter(item => Number(item) == colorValue).length != 0) {
                      color = obj.color
                    }
                  } else if (obj.compare == 8) {
                    //between
                    let arr = JSON.parse(obj.compareVal);
                    if (Number(colorValue) > Number(arr[0]) && Number(colorValue) < Number(arr[1])) {
                      color = obj.color
                    }
                  }
                }
                return {
                  border: `${item.borderWidth}px solid ${this.getRgba(item.borderColor,item.opacity)}`,
                  borderRadius: item.borderRadius + 'px',
                  backgroundColor: color
                }
              }
            }
          }
          return {
            border: `${item.borderWidth}px solid ${this.getRgba(item.borderColor,item.opacity)}`,
            borderRadius: item.borderRadius + 'px',
            backgroundColor: this.getRgba(item.bgColor, item.opacity)
          }
        }
      },
      // 进度条
      getProgressVal() {
        return (item, type) => {
          let companyId = this.item.companyId || this.$store.state.companyId //this.isCompany?this.$store.state.companyId:this.item.companyId
          let company = this.indexPreviewData.find(item => item.companyId == companyId)
          if (company && company.deviceList && item.progressAttr && item.progressAttr.length) {
            let device = company.deviceList.find(item => item.code == this.item.progressAttr[0])
            if (device && device.valueList && device.attrDataList) {
              let value = device.valueList.find(item => item.code == this.item.progressAttr[1])
              // if(this.item.id==114){
              //   debugger
              // }
              if (value) {
                value = value.value
                let attrData = device.attrDataList.find(item => item.code == this.item.progressAttr[1])
                if (attrData) {
                  let max = attrData.dataType.specs.max || 1
                  let step = attrData.dataType.specs.step
                  let decimalIndex = step.indexOf('.');
                  let fixed = null
                  if (decimalIndex != -1) {
                    fixed = step.length - decimalIndex - 3
                  }
                  value = Number(value) / Number(max) * 100
                  if(fixed>=0){
                    value = value.toFixed(fixed)
                  }
                }
                if (type == 1) {
                  return value
                } else if (item.colorList.length) {
                  let device = company.deviceList.find(item => item.code == this.item.colorAttr[0])
                  if (device && device.valueList) {
                    let colorValue = device.valueList.find(item => item.code == this.item.colorAttr[1])
                    if (colorValue) {
                      colorValue = Number(colorValue.value)
                      let color = item.fgColor
                      for (let obj of item.colorList) {
                        if (obj.compare == 1) {
                          // >
                          if (colorValue > obj.compareVal) {
                            color = obj.color
                          }
                        } else if (obj.compare == 2) {
                          // >=
                          if (colorValue >= obj.compareVal) {
                            color = obj.color
                          }
                        } else if (obj.compare == 3) {
                          // ==
                          if (colorValue == obj.compareVal) {
                            color = obj.color
                          }
                        } else if (obj.compare == 4) {
                          // <
                          if (colorValue < obj.compareVal) {
                            color = obj.color
                          }
                        } else if (obj.compare == 5) {
                          // <=
                          if (colorValue <= obj.compareVal) {
                            color = obj.color
                          }
                        } else if (obj.compare == 6) {
                          // !=
                          if (colorValue != obj.compareVal) {
                            color = obj.color
                          }
                        } else if (obj.compare == 7) {
                          //in
                          let arr = JSON.parse(obj.compareVal);
                          if (arr.filter(item => Number(item) == colorValue).length != 0) {
                            color = obj.color
                          }
                        } else if (obj.compare == 8) {
                          //between
                          let arr = JSON.parse(obj.compareVal);
                          if (Number(colorValue) > Number(arr[0]) && Number(colorValue) < Number(arr[1])) {
                            color = obj.color
                          }
                        }
                      }
                      return {
                        width: value + "%",
                        height: item.barHeight + 'px',
                        backgroundColor: color,
                        borderRadius: item.borderRadius + 'px'
                      }
                    }
                  }
                  return {
                    width: value + "%",
                    height: item.barHeight + 'px',
                    backgroundColor: this.getRgba(item.fgColor, item.opacity),
                    borderRadius: item.borderRadius + 'px'
                  }
                }
              }
            }
          }
          if (type == 1) {
            return 0
          } else {
            return {
              width: "0%",
              height: item.barHeight + 'px',
              backgroundColor: item.fgColor,
              borderRadius: item.borderRadius + 'px'
            }
          }
        }
      },
      // 图片
      getImgUrl() {
        return (item) => {
          if (item.controlId == 12 && item.DeviceAttr && item.lampUrl1 && item.lampUrl2) {
            let companyId = this.item.companyId || this.$store.state.companyId
            let company = this.indexPreviewData.find(item => item.companyId == companyId)
            if (company && company.deviceList) {
              let device = company.deviceList.find(item => item.code == this.item.DeviceAttr[0])
              if (device && device.valueList && device.attrDataList) {
                let value = device.valueList.find(item => item.code == this.item.DeviceAttr[1])
                if (value && value.value == 0) {
                  return require('@/../static/indexEditorIcon/' + item.lampUrl1)
                } else if (value && value.value == 1) {
                  return require('@/../static/indexEditorIcon/' + item.lampUrl2)
                }
              }
            }
          }
          return require('@/../static/indexEditorIcon/' + item.url)
        }
      },
      // 素材
      getImgUrl2() {
        return (item) => {
          let url = item.url
          if (item.statusAttr) {
            let companyId = this.item.companyId || this.$store.state.companyId
            let company = this.indexPreviewData.find(item => item.companyId == companyId)
            if (company && company.deviceList) {
              let device = company.deviceList.find(item => item.code == this.item.statusAttr[0])
              if (device && device.valueList && device.attrDataList) {
                let value = device.valueList.find(item => item.code == this.item.statusAttr[1])
                if (value) {
                  value = Number(value.value)
                  for (let status of this.item.statusList) {
                    if ((status.compareVal || status.compareVal == 0) && status.compare) {
                      let itemValue = Number(status.compareVal)
                      let isTrue = false
                      if (status.compare == 1) {
                        // >
                        if (value > itemValue) {
                          isTrue = true;
                        }
                      } else if (status.compare == 2) {
                        // >=
                        if (value >= itemValue) {
                          isTrue = true;
                        }
                      } else if (status.compare == 3) {
                        // ==
                        if (value == itemValue) {
                          isTrue = true;
                        }
                      } else if (status.compare == 4) {
                        // <
                        if (value < itemValue) {
                          isTrue = true;
                        }
                      } else if (status.compare == 5) {
                        // <=
                        if (value <= itemValue) {
                          isTrue = true;
                        }
                      } else if (status.compare == 6) {
                        // !=
                        if (value != itemValue) {
                          isTrue = true;
                        }
                      } else if (status.compare == 7) {
                        //in
                        let arr = JSON.parse(status.compareVal);
                        if (arr.filter(item => Number(item) == value).length != 0) {
                          isTrue = true;
                        }
                      } else if (status.compare == 8) {
                        //between
                        let arr = JSON.parse(status.compareVal);
                        if (Number(value) > Number(arr[0]) && Number(value) < Number(arr[1])) {
                          isTrue = true;
                        }
                      }
                      if (isTrue) {
                        url = status.url
                      }
                    }
                  }
                }
              }
            }
          }
          if (url.includes('http')) {
            url = url.substr(url.indexOf('/image'))
          }
          // url = 'https://iot.yonjie.com' + url
          // console.log(url)
          return url
        }
      },
      // 管道背景
      getConduitBg() {
        return (item) => {
          let companyId = this.item.companyId || this.$store.state.companyId
          let company = this.indexPreviewData.find(item => item.companyId == companyId)
          if (company && company.deviceList && item.DeviceAttr) {
            let device = company.deviceList.find(item => item.code == this.item.DeviceAttr[0])
            if (device && device.valueList && device.attrDataList) {
              let value = device.valueList.find(item => item.code == this.item.DeviceAttr[1])
              let itemValue = Number(item.compareVal)
              let gif = false
              if (value) {
                value = value.value
                // if(this.item.ShowAttrName){
                //   let name = attrData?attrData.name:''
                //   return name + ":" + value
                // }
                // return value
                if (item.compare == 1) {
                  // >
                  if (value > itemValue) {
                    gif = true;
                  }
                } else if (item.compare == 2) {
                  // >=
                  if (value >= itemValue) {
                    gif = true;
                  }
                } else if (item.compare == 3) {
                  // ==
                  if (value == itemValue) {
                    gif = true;
                  }
                } else if (item.compare == 4) {
                  // <
                  if (value < itemValue) {
                    gif = true;
                  }
                } else if (item.compare == 5) {
                  // <=
                  if (value <= itemValue) {
                    gif = true;
                  }
                } else if (item.compare == 6) {
                  // !=
                  if (value != itemValue) {
                    gif = true;
                  }
                } else if (item.compare == 7) {
                  //in
                  let arr = JSON.parse(item.compareVal);
                  if (arr.filter(item => Number(item) == value).length != 0) {
                    gif = true;
                  }
                } else if (item.compare == 8) {
                  //between
                  let arr = JSON.parse(item.compareVal);
                  if (Number(value) > Number(arr[0]) && Number(value) < Number(arr[1])) {
                    gif = true;
                  }
                }
                if (gif) {
                  return {
                    backgroundImage: 'url(' + require('@/../static/indexEditorIcon/' + item.imageGif) + ')'
                  }
                }
              }
            }
          }
          return {
            backgroundImage: 'url(' + require('@/../static/indexEditorIcon/' + item.imagePng) + ')'
          }
        }
      },

      // 存储属性值的数组
      indexPreviewData() {
        return this.$store.state.indexPreviewData
      },
      // 当前发生时间变化的控件对象
      changTimeObj() {
        return this.$store.state.changTimeObj
      },
      // 基本样式 宽高和定位
      initStyle() {
        return (item) => {
          return {
            left: item.x + 'px',
            top: item.y + 'px',
            width: item.width + 'px',
            height: item.height + 'px',
            zIndex: item.zIndex,
            // 需求取消
            // transform: `rotate(${item.rotation||0}deg)`
          }
        }
      },
      ConnectorUrl() {
        return (id) => {
          if (id) {
            let url = this.ConnectorList.filter(item => item.id == id)[0].url
            return require('@/../static/indexEditorIcon/' + url)
          } else {
            return null
          }
        }
      },
      DragList() {
        return this.$store.state.DragList
      },
      getDate() {
        return (time) => {
          var y = time.getFullYear()
          var m = time.getMonth() + 1
          var d = time.getDate()
          if (m < 10) {
            m = "0" + m
          }
          if (d < 10) {
            d = "0" + d
          }
          return `${y}.${m}.${d}`
        }
      },
      getDay() {
        return (time) => {
          var d = time.getDay()
          switch (d) {
            case 1:
              d = '一'
              break;
            case 2:
              d = '二'
              break;
            case 3:
              d = '三'
              break;
            case 4:
              d = '四'
              break;
            case 5:
              d = '五'
              break;
            case 6:
              d = '六'
              break;
            case 0:
              d = '日'
              break;
          }
          return '星期' + d
        }
      }
    },
    methods: {
      changeBlock(index,indexPath){
        var pathArr = index.toString().split('-'),index=0
        var panels = this.DragList.filter(item=>item.type=='panel'&&item.deleted != true)
        // console.log(index,indexPath)
        var mapBlock=function(panel){
          panel.activeBlock = pathArr[index]
          index+=1
          let block = panel.blockContentList.find(item=>item.id==panel.activeBlock)
          if(block&&block.drags.length){
            let panels = block.drags.filter(item=>item.type=='panel'&&item.deleted != true)
            mapPanel(panels)
          }
        }
        var mapPanel=function(panels){
          if(panels.length==1){
            var panel = panels[0]
            mapBlock(panel)
          }else{
            var panel = panels.find(item=>item.id == pathArr[index])
            if(panel){
              index+=1
              mapBlock(panel)
            }
          }
        }
        if(panels.length==1){
          mapBlock(panels[0])
        }else{
          mapPanel(panels)
        }
      },
      // 获取日历数据
      async getCalendarData() {
        for (let i in this.item.attrList) {
          var attr = this.item.attrList[i]
          let nowY = this.calendarValue.getFullYear(),
            nowM = this.calendarValue.getMonth() + 1,
            lastTime = new Date(nowY + '-' + nowM + '-1'),
            last = new Date(lastTime.setMonth(this.calendarValue.getMonth() + 1)),
            lastY = last.getFullYear(),
            lastM = last.getMonth() + 1
          if (attr.type == 2) { //设备属性
            attr.deviceCode = attr.attrKey[0]
            attr.propertyCode = attr.attrKey[1]
            if (!attr.deviceName) { //首次获取时
              let company = this.$store.state.indexPreviewData.find(item => item.companyId == attr.companyId),
                deviceList = this.deviceList;
              if (company && company.deviceList) {
                deviceList = company.deviceList
              }
              let dev = deviceList.find(devItem => devItem.code == attr.deviceCode)
              if (dev) {
                attr.deviceName = dev.name
                attr.propertyName = await this.getPropertyName(attr.deviceCode, attr.propertyCode, dev, attr)
                attr.name = attr.deviceName + '/' + attr.propertyName
                if (this.item.unit) {
                  attr.name += '(' + this.item.unit + ')'
                } else if (attr.unit) {
                  attr.name += '(' + attr.unit + ')'
                }
              } else {

              }
            }
            let parmes = {
              frameType: 3, //类型 1自然时段，2相对时段，3指定时段
              timeFrameType: 3, //窗口类型，1近，2上
              timeFrameSize: 1, //跨度
              timeFrame: 5, // 跨度单位 1分钟，2小时，3天，5月，7年
              timeWindow: 3, //时间粒度，0秒，1分钟，2小时，3天，5月，7年
              timeWindowSize: 1, //粒度大小
              beginFrame: new Date(nowY + '-' + nowM + '-1 0:0:0').getTime() - 1,
              endFrame: new Date(lastY + '-' + lastM + '-1 0:0:0').getTime() - 1,
              deviceCode: attr.deviceCode,
              propertyCode: attr.propertyCode
            }
            // console.log("获取日历数据")
            let res = await this.getChartsData('/Report/getData2', parmes);
            if (res.result && res.result.data.length && res.result.data[0].data.length) {
              if (attr.errorDown || attr.errorUp || attr.warnDown || attr.warnUp) {
                for (let data of res.result.data[0].data) {
                  data.day = this.changeDate(data.time)
                  if (data.value[0] || data.value[0] == 0) {
                    let value1 = Number(data.value[0]),
                      warningColor = ""
                    if (attr.warnUp) {
                      if (value1 >= Number(attr.warnUp)) {
                        warningColor = '#ff7e00'
                      }
                    }
                    if (attr.warnDown) {
                      if (value1 <= Number(attr.warnDown)) {
                        warningColor = '#ff7e00'
                      }
                    }
                    if (attr.errorUp) {
                      if (value1 >= Number(attr.errorUp)) {
                        warningColor = '#ff0000'
                      }
                    }
                    if (attr.errorDown) {
                      if (value1 <= Number(attr.errorDown)) {
                        warningColor = '#ff0000'
                      }
                    }
                    data.warningColor = warningColor
                  }
                }
              } else {
                for (let data of res.result.data[0].data) {
                  data.warningColor = ""
                  data.day = this.changeDate(data.time)
                }
              }
              attr.dataArr = res.result.data[0].data
            } else {
              attr.dataArr = []
            }
          } else {
            let parmes = {
              frameType: 3, //类型 1自然时段，2相对时段，3指定时段
              timeFrameType: 3, //窗口类型，1近，2上
              timeFrameSize: 1, //跨度
              timeFrame: 5, // 跨度单位 1分钟，2小时，3天，5月，7年
              timeWindow: 3, //时间粒度，0秒，1分钟，2小时，3天，5月，7年
              timeWindowSize: 1, //粒度大小
              beginFrame: new Date(nowY + '-' + nowM + '-1 0:0:0').getTime() - 1,
              endFrame: new Date(lastY + '-' + lastM + '-1 0:0:0').getTime() - 1,
              id: attr.datasetId,
              code: localStorage.getItem("screenGroupCode")
            }
            let res = await this.getChartsData("/v2/Dataset/getData", parmes);
            if (res.result && res.result[0]) {
              if (!attr.deviceName && res.result[0].deviceCode) { //首次获取时
                attr.deviceCode = res.result[0].deviceCode
                attr.propertyCode = res.result[0].propertyCode
                attr.name = res.result[0].name
                let company = this.$store.state.indexPreviewData.find(item => item.companyId == attr.companyId),
                  deviceList = this.deviceList;
                if (company && company.deviceList) {
                  deviceList = company.deviceList
                }
                let dev = deviceList.find(devItem => devItem.code == attr.deviceCode)
                if (dev) {
                  attr.deviceName = dev.name
                  attr.propertyName = await this.getPropertyName(attr.deviceCode, attr.propertyCode, dev, attr)
                  if (this.item.unit) {
                    attr.name += '(' + this.item.unit + ')'
                  } else if (attr.unit) {
                    attr.name += '(' + attr.unit + ')'
                  }
                } else {

                }
              }
              if (attr.errorDown || attr.errorUp || attr.warnDown || attr.warnUp) {
                for (let data of res.result[0].data) {
                  data.day = this.changeDate(data.time)
                  if (data.value[0] || data.value[0] == 0) {
                    let value1 = Number(data.value[0]),
                      warningColor = ""
                    if (attr.warnUp) {
                      if (value1 >= Number(attr.warnUp)) {
                        warningColor = '#ff7e00'
                      }
                    }
                    if (attr.warnDown) {
                      if (value1 <= Number(attr.warnDown)) {
                        warningColor = '#ff7e00'
                      }
                    }
                    if (attr.errorUp) {
                      if (value1 >= Number(attr.errorUp)) {
                        warningColor = '#ff0000'
                      }
                    }
                    if (attr.errorDown) {
                      if (value1 <= Number(attr.errorDown)) {
                        warningColor = '#ff0000'
                      }
                    }
                    data.warningColor = warningColor
                  }
                }
              } else {
                for (let data of res.result[0].data) {
                  data.warningColor = ""
                  data.day = this.changeDate(data.time)
                }
              }
              attr.dataArr = res.result[0].data
            } else {
              attr.dataArr = []
            }
          }
          this.$set(this.attrList, i, attr)
        }
        this.$nextTick(()=>{
          this.$forceUpdate()
        })
        this.calendarShow = true
      },
      // 修改时间
      changeDate(e) {
        // console.log("changeDate")
        if (this.item.timeVal) {
          let obj = {
            id: this.item.id
          }
          this.$store.state.changTimeObj = obj
        }
      },
      // 修改日历时间
      changeDate2() {
        if (this.item.calendarValue) {
          let obj = {
            id: this.item.id
          }
          this.$store.state.changTimeObj = obj
        }
      },
      // 修改时间类型
      setDateType(e) {
        if (e != this.item.dateType) {
          this.item.dateType = e
          this.changeDate()
        }
      },
      timepickShow() {
        let ref
        if (this.item.dateType == 2) {
          ref = this.$refs['hourpick' + this.item.id]
        } else if (this.item.dateType == 3) {
          ref = this.$refs['datepick' + this.item.id]
        } else if (this.item.dateType == 5) {
          ref = this.$refs['monthpick' + this.item.id]
        } else if (this.item.dateType == 7) {
          ref = this.$refs['yearpick' + this.item.id]
        }
        ref.focus && ref.focus()
      },
      // 获取列表
      getList() {
        let companyId = this.item.companyId || this.$store.state.companyId
        if (companyId) {
          let data = {
            companyId: companyId,
            pageNumber: 1,
            length: 30
          }
          this.get('/DeviceAlarm/query', data).then(res => {
            if (res.success) {
              this.listData = res.result.data
            } else {
              this.$message({
                type: "warning",
                message: "获取报警列表失败：" + res.message
              })
            }
          })
        }
      },
      // 获取设备列表
      getDeviceList(cId) {
        // console.log("getDeviceList",cId,this.item.companyId,this.$store.state.companyId)
        var companyId2 = cId
        return new Promise((resolve, reject) => {
          let companyId = companyId2 || this.item.companyId || this.$store.state.companyId;
          if (!companyId) {
            resolve()
          } else {
            let company = this.$store.state.indexPreviewData.find(item => item.companyId == companyId)
            if (company && company.deviceList) {
              this.deviceList = company.deviceList
              resolve()
            } else {
              this.get('/Device/getList', {
                companyId: companyId
              }).then(res => {
                if (res.success) {
                  this.deviceList = res.result
                  let obj = {
                    companyId: companyId,
                    deviceList: res.result
                  }
                  this.$forceUpdate()
                  this.get("/VirtualDevice/get", {
                    companyId: companyId
                  }).then(res2 => {
                    if (res2.success) {
                      res2.result.name = "虚拟设备"
                      this.deviceList.push(res2.result)
                      obj.deviceList.push(res2.result)
                      this.$set(this.indexPreviewData, this.indexPreviewData.length, obj)
                      this.get('/VirtualDevice/getPropertyList', {
                        companyId: companyId,
                        deviceId: res2.result.id
                      }).then(res3 => {
                        if (res3.success) {
                          res2.result.attrList = res3.result
                        } else {
                          this.$message({
                            type: "warning",
                            message: "获取虚拟设备扩展属性失败：" + res.message
                          })
                        }
                      })
                    } else {
                      this.$message({
                        type: "warning",
                        message: "获取虚拟设备失败：" + res.message
                      })
                    }
                    resolve()
                  })
                } else {
                  this.$message({
                    type: "warning",
                    message: "获取设备列表失败：" + res.message
                  })
                }
                resolve()
              })
            }

          }

        })
      },
      // 通知父组件订阅主题
      emitMqtt(url) {
        this.$emit('mqttUrl', url)
      },
      // 由父组件接收的mqtt消息更新页面数据
      async viewUpdate(code) {
        if (this.$refs.children) {
          this.$refs.children.forEach((control) => {
            if (control.item.type != "graph" && control.item.type != "list" && control.item.type != "ranking") {
              control.viewUpdate(code)
            }
          })
        }
        if (this.item.type != "graph" && this.item.type != "list" && this.item.type != "ranking") {
          var timer = setTimeout(() => {
            // this.$forceUpdate()
            this.$nextTick(() => {
              this.$forceUpdate()
            })
            clearTimeout(timer)
          }, 200)
        }
      },
      // 获取数据 - 弃用，改为由index.vue遍历控件获取数据
      // async getData() {
      //   if (this.item.DeviceAttrBlock && this.item.DeviceAttrBlock.length && this.item.DeviceCode) {
      //     if (this.isCompany) {
      //       await this.getDevice(this.$store.state.companyId, this.item.DeviceCode)
      //     } else {
      //       await this.getDevice(this.item.companyId, this.item.DeviceCode)
      //     }
      //   }
      //   if (this.item.type == "textSpan" && this.item.spanShowValue) {
      //     if (this.item.DeviceAttr) {
      //       // this.getValue(this.item.DeviceAttr)
      //       if (this.isCompany) {
      //         await this.getDevice(this.$store.state.companyId, this.item.DeviceAttr[0])
      //       } else {
      //         await this.getDevice(this.item.companyId, this.item.DeviceAttr[0])
      //       }
      //       this.$emit('mqttUrl', `sys/device/${this.item.DeviceAttr[0]}/property/push`)
      //       // console.log(this.item)
      //       try{
      //         if (this.item.ShowAttrCode && this.item.ShowAttrCode[0] != this.item.DeviceAttr[0]) {
      //           this.$emit('mqttUrl', `sys/device/${this.item.ShowAttrCode[0]}/property/push`)
      //           if (this.isCompany) {
      //             await this.getDevice(this.$store.state.companyId, this.item.ShowAttrCode[0])
      //           } else {
      //             await this.getDevice(this.item.companyId, this.item.ShowAttrCode[0])
      //           }
      //         }
      //       }catch(err){
      //         // console.log("error",err)
      //       }
      //     }
      //   } else if ((this.item.type == "conduit" || this.item.controlId == 12) && this.item.DeviceAttr) {
      //     if (this.isCompany) {
      //       await this.getDevice(this.$store.state.companyId, this.item.DeviceAttr[0])
      //     } else if (this.item.companyId) {
      //       await this.getDevice(this.item.companyId, this.item.DeviceAttr[0])
      //     }
      //     this.$emit('mqttUrl', `sys/device/${this.item.DeviceAttr[0]}/property/push`)
      //   } else if (this.item.type == "progress" && this.item.progressAttr) {
      //     if (this.isCompany) {
      //       await this.getDevice(this.$store.state.companyId, this.item.progressAttr[0])
      //     } else if (this.item.companyId) {
      //       await this.getDevice(this.item.companyId, this.item.progressAttr[0])
      //     }
      //     this.$emit('mqttUrl', `sys/device/${this.item.progressAttr[0]}/property/push`)
      //     if (this.item.colorAttr) {
      //       this.$emit('mqttUrl', `sys/device/${this.item.colorAttr[0]}/property/push`)
      //       if (this.isCompany) {
      //         await this.getDevice(this.$store.state.companyId, this.item.colorAttr[0])
      //       } else if (this.item.companyId) {
      //         await this.getDevice(this.item.companyId, this.item.colorAttr[0])
      //       }
      //     }
      //   } else if (this.item.controlId == 11 && this.item.DeviceId) {
      //     let device = this.$store.state.deviceWarningList.find(item => item.deviceId = this.item.DeviceId)
      //     if (!device) {
      //       let device = {
      //         deviceId: this.item.DeviceId,
      //         status: 1
      //       }
      //       this.$emit('mqttUrl', `sys/device/${this.item.DeviceCode}/status/push`)
      //       this.$store.state.deviceWarningList.push(device)
      //     }
      //   } else if (this.item.type == "circular" || this.item.type == "rectangle") {
      //     if (this.item.colorAttr) {
      //       this.$emit('mqttUrl', `sys/device/${this.item.colorAttr[0]}/property/push`)
      //       if (this.isCompany) {
      //         await this.getDevice(this.$store.state.companyId, this.item.colorAttr[0])
      //       } else if (this.item.companyId) {
      //         await this.getDevice(this.item.companyId, this.item.colorAttr[0])
      //       }
      //     }
      //   } else if (this.item.type == "control") {
      //     if (this.isCompany) {
      //       await this.getDevice(this.$store.state.companyId, this.item.DeviceCode)
      //       if (this.item.statusAttr && this.item.statusAttr[0] != this.item.DeviceCode) {
      //         await this.getDevice(this.$store.state.companyId, this.item.statusAttr[0])
      //       }
      //     } else if (this.item.companyId) {
      //       await this.getDevice(this.item.companyId, this.item.DeviceCode)
      //       if (this.item.statusAttr && this.item.statusAttr[0] != this.item.DeviceCode) {
      //         await this.getDevice(this.item.companyId, this.item.statusAttr[0])
      //       }
      //     }
      //   }
      // },

      // 根据企业id，设备code获取设备,设备属性值
      getDevice(companyId, deviceCode) {
        let company = this.indexPreviewData.find(item => item.companyId == companyId)
        if (company) {
          let device = company.deviceList.find(item => item.code == deviceCode)
          if (device) {
            // this.getDeviceData(companyId,device)
            // 获取属性值
            if (deviceCode.substr(0, 2) == "_V" && !device.valueList) {
              this.get('/VirtualDevice/getPropertyValue', {
                deviceId: device.id
              }).then(res => {
                if (res.success) {
                  this.$set(device, 'valueList', res.result)
                  this.$forceUpdate()
                }
              })
            } else if (!device.valueList) {
              this.get('/Device/getPropertyValue', {
                deviceId: device.id
              }).then(res => {
                if (res.success) {
                  this.$set(device, 'valueList', res.result)
                }
              })
            }
            this.getDeviceAttrData(companyId, device)
          }
        } else {
          this.get('/Device/getList', {
            companyId: companyId
          }).then(res => {
            if (res.success) {
              let obj = {
                companyId: companyId,
                deviceList: res.result
              }
              this.get("/VirtualDevice/get", {
                companyId: companyId
              }).then(res2 => {
                if (res2.success) {
                  res2.result.name = "虚拟设备"
                  obj.deviceList.unshift(res2.result)
                  this.$set(this.indexPreviewData, this.indexPreviewData.length, obj)
                  let device = obj.deviceList.find(item => item.code == deviceCode)
                  if (device) {
                    // this.getDeviceData(companyId,device)
                    if (deviceCode.substr(0, 2) == "_V" && !device.valueList) {
                      this.get('/VirtualDevice/getPropertyValue', {
                        deviceId: device.id
                      }).then(res => {
                        if (res.success) {
                          // device.valueList=res.result
                          this.$set(device, 'valueList', res.result)
                          // this.$forceUpdate()
                        }
                      })
                    } else if (!device.valueList) {
                      this.get('/Device/getPropertyValue', {
                        deviceId: device.id
                      }).then(res => {
                        if (res.success) {
                          // device.valueList=res.result
                          this.$set(device, 'valueList', res.result)
                          // this.$forceUpdate()
                        }
                      })
                    }
                    this.getDeviceAttrData(companyId, device)
                  }
                }
              })
            }
          })
        }
      },
      // 据企业id，设备对象获取设备属性值
      getDeviceAttrData(companyId, device) {
        // 初次请求过的忽略 !device.attrDataList
        if (!device.attrDataList) {
          if (device.name == "虚拟设备") {
            this.get('/VirtualDevice/getPropertyList', {
              deviceId: device.id
            }).then(res => {
              if (res.success) {
                device.attrDataList = res.result
                this.viewUpdate()
              }
            })
          } else {
            this.get('/ProductFeature/getByDeviceCode', {
              code: device.code
            }).then(res => {
              if (res.success) {
                let data = JSON.parse(res.result).properties;
                let arr = [];
                if (typeof device.propertySet == 'string') {
                  device.propertySet = device.propertySet.split(',')
                }
                for (let item of data) {
                  if (device.propertySet.includes(item.identifier)) {
                    item.code = item.identifier
                    item.type = item.dataType.type
                    item.unit = item.dataType.specs.unit
                    item.unitName = item.dataType.specs.unitName
                    item.step = item.dataType.specs.step
                    arr.push(item)
                  }
                }
                device.attrDataList = arr
                this.viewUpdate()
              }
            })
          }
        }
      },
      // 格式化文本时间
      resetTextTime() {
        let self = this
        let mapTree = function(arr = []) {
          for (let control of arr) {
            if (control.id == self.item.chartsTimeId && !control.deleted) {
              if (control.controlId == 36) { //日历
                var time = new Date()
                if (control.calendarValue) {
                  time = control.calendarValue
                }
                self.item.timeType = 3
                self.item.granularityUint = 3
                self.item.granularity = 1
                var y = time.getFullYear()
                var m = time.getMonth() + 1
                var d = time.getDate()
                var beginFrame = new Date(y + '/' + m + '/' + d + ' 0:0:0').getTime()
                let parmes = {
                  frameType: 3, //时段类型，1自然时段，2相对时段，3指定时段
                  timeFrame: 3, //时间窗口，1分钟，2小时，3天，5月，7年
                  timeWindow: 3, //时间粒度单位 0秒，1分钟，2小时，3天，5月，7年
                  timeWindowSize: 1, //粒度大小
                  beginFrame: beginFrame,
                  deviceCode: self.item.DeviceAttr[0],
                  propertyCode: self.item.DeviceAttr[1],
                  endFrame: beginFrame + (60000 * 60 * 24),
                }
                self.getTextData(parmes)
              } else {
                var beginFrame = Number(control.timeVal)
                let parmes = {
                  frameType: 3,
                  beginFrame: beginFrame,
                  timeWindowSize: 1,
                  deviceCode: self.item.DeviceAttr[0],
                  propertyCode: self.item.DeviceAttr[1]
                }
                switch (control.dateType) {
                  case 2:
                    //时：
                    parmes.endFrame = beginFrame + 60000 * 60
                    parmes.timeFrame = 2,
                      parmes.timeWindow = 2
                    break;
                  case 3:
                    //天：
                    parmes.endFrame = beginFrame + 60000 * 60 * 24
                    parmes.timeFrame = 3,
                      parmes.timeWindow = 3
                    break;
                  case 5:
                    //月：
                    var y = new Date(beginFrame).getFullYear()
                    var m = new Date(beginFrame).getMonth()
                    parmes.beginFrame = new Date(y + '/' + (m + 1) + '/1 0:0:0').getTime()
                    var next = new Date(parmes.beginFrame).setMonth(m + 1)
                    parmes.endFrame = new Date(next).getTime()
                    parmes.timeFrame = 5,
                      parmes.timeWindow = 5
                    break;
                  case 7:
                    //年
                    var y = new Date(beginFrame).getFullYear()
                    parmes.beginFrame = new Date(y + '/1/1 0:0:0').getTime()
                    var next = new Date(parmes.beginFrame).setFullYear(y + 1)
                    parmes.endFrame = new Date(next).getTime()
                    parmes.timeFrame = 7,
                    parmes.timeWindow = 7
                    break;
                }
                // console.log(parmes)
                self.getTextData(parmes)
              }
            } else if ((control.type == 'makeUp' || control.type == 'proup') && !control.deleted) {
              mapTree(control.children)
            } else if (control.type == 'panel' && !control.deleted) {
              for (let chil of control.blockContentList) {
                mapTree(chil.drags)
              }
            }
          }
        }
        mapTree(this.DragList)
      },
      // 格式化图表时间
      resetTime() {
        let self = this
        let mapTree = function(arr = []) {
          for (let control of arr) {
            if (control.id == self.item.chartsTimeId && !control.deleted) {
              // 关联时间选择器  跨度为1 单位为时间选择器的单位，时间类型为指定，开始时间为时间单位开始值，结束时间为1单位的时间
              if (control.controlId == 36) { //日历
                var time = new Date()
                if (control.calendarValue) {
                  time = control.calendarValue
                }
                self.item.timeType = 3
                self.item.rate = control.rate || self.item.rate
                self.item.granularityUint = 2
                self.item.granularity = 1
                self.item.oldData = false
                var y = time.getFullYear()
                var m = time.getMonth() + 1
                var d = time.getDate()
                self.item.beginFrame = new Date(y + '/' + m + '/' + d + ' 0:0:0').getTime()
                // self.item.endFrame = new Date(y + '/' + m + '/' + d + ' 23:59:59').getTime()
                self.item.endFrame = self.item.beginFrame + 1000 * 60 * 60 * 24
                self.initCharts(true, false)
                let time = 5000
                if (self.item.rate && self.item.rate != '0') {
                  time = Number(self.item.rate) * 60 * 1000
                } else if (self.item.rate == 0) {
                  switch (self.item.granularityUint) {
                    case 0:
                      time = self.item.granularity <= 5 ? 5000 : self.item.granularity * 1000
                      break;
                    case 1:
                      time = self.item.granularity * 1000 * 60
                      break;
                    case 2:
                      time = self.item.granularity * 1000 * 60 * 60
                      break;
                    case 3:
                      time = self.item.granularity * 1000 * 60 * 60 * 24
                      break;
                    case 5:
                      time = self.item.granularity * 1000 * 60 * 60 * 24 * 30
                      break;
                    case 7:
                      time = self.item.granularity * 1000 * 60 * 60 * 24 * 365
                      break;
                  }
                }
                if (self.timer) {
                  clearInterval(self.timer)
                }
                self.timer = setInterval(() => {
                  self.initCharts(false, false)
                }, time)
              } else {
                self.item.timeType = 3
                self.item.oldData = control.oldData
                self.item.rate = control.rate
                if (control.timeVal) {
                  self.item.beginFrame = Number(control.timeVal)
                  // 根据所选时间计算时间粒度、跨度和结束时间 小程序 ios系统 new Date() 'yyyy-mm-dd'得改成'yyyy/mm/dd'
                  switch (control.dateType) {
                    case 2:
                      //时：粒度 30秒 => 1分
                      self.item.granularityUint = 1
                      self.item.granularity = 1
                      self.item.endFrame = self.item.beginFrame + 1000 * 60 * 60
                      if (control.oldData) { //上期数据
                        self.item.oldBeginFrame = self.item.beginFrame - 1000 * 60 * 60
                        self.item.oldEndFrame = self.item.beginFrame
                      }
                      break;
                    case 3:
                      //天：粒度 10分 => 1时
                      self.item.granularityUint = 2
                      self.item.granularity = 1
                      var y = new Date(self.item.beginFrame).getFullYear()
                      var m = new Date(self.item.beginFrame).getMonth() + 1
                      var d = new Date(self.item.beginFrame).getDate()
                      self.item.beginFrame = new Date(y + '/' + m + '/' + d + ' 0:0:0').getTime()
                      // self.item.endFrame = new Date(y + '/' + m + '/' + d + ' 23:59:59').getTime()
                      self.item.endFrame = self.item.beginFrame + 1000 * 60 * 60 * 24
                      if (control.oldData) { //上期数据
                        self.item.oldBeginFrame = self.item.beginFrame - 1000 * 60 * 60 * 24
                        self.item.oldEndFrame = self.item.beginFrame
                      }
                      break;
                    case 5:
                      //月：粒度 2时 => 1天
                      self.item.granularityUint = 3
                      self.item.granularity = 1
                      var y = new Date(self.item.beginFrame).getFullYear()
                      var m = new Date(self.item.beginFrame).getMonth()
                      self.item.beginFrame = new Date(y + '/' + (m + 1) + '/1 0:0:0').getTime()
                      var next = new Date(self.item.beginFrame).setMonth(m + 1)
                      self.item.endFrame = new Date(next).getTime()
                      if (control.oldData) { //上期数据
                        var old = new Date(self.item.beginFrame).setMonth(m - 1) //月份-1
                        self.item.oldBeginFrame = new Date(old).getTime()
                        self.item.oldEndFrame = self.item.beginFrame
                      }
                      break;
                    case 7:
                      //年：粒度 1天 => 1月
                      self.item.granularityUint = 5
                      self.item.granularity = 1
                      var y = new Date(self.item.beginFrame).getFullYear()
                      self.item.beginFrame = new Date(y + '/1/1 0:0:0').getTime()
                      var next = new Date(self.item.beginFrame).setFullYear(y + 1)
                      self.item.endFrame = new Date(next).getTime()
                      if (control.oldData) { //上期数据
                        var old = new Date(self.item.beginFrame).setFullYear(y - 1) //年份-1
                        self.item.oldBeginFrame = new Date(old).getTime()
                        self.item.oldEndFrame = self.item.beginFrame
                      }
                      break;
                  }
                  // console.log(self.item.beginFrame,self.item.endFrame)
                  self.initCharts(true, false)
                  // let time = 5000
                  // if (self.item.rate && self.item.rate != '0') {
                  //   time = Number(self.item.rate) * 60 * 1000
                  // } else if (self.item.rate == 0) {
                  //   switch (self.item.granularityUint) {
                  //     case 0:
                  //       time = self.item.granularity <= 5 ? 5000 : self.item.granularity * 1000
                  //       break;
                  //     case 1:
                  //       time = self.item.granularity * 1000 * 60
                  //       break;
                  //     case 2:
                  //       time = self.item.granularity * 1000 * 60 * 60
                  //       break;
                  //     case 3:
                  //       time = self.item.granularity * 1000 * 60 * 60 * 24
                  //       break;
                  //     case 5:
                  //       time = self.item.granularity * 1000 * 60 * 60 * 24 * 30
                  //       break;
                  //     case 7:
                  //       time = self.item.granularity * 1000 * 60 * 60 * 24 * 365
                  //       break;
                  //   }
                  // }
                  // if (self.timer) {
                  //   clearInterval(self.timer)
                  // }
                  // self.timer = setInterval(() => {
                  //   self.initCharts(false, false)
                  // }, time)
                }
              }
            } else if ((control.type == 'makeUp' || control.type == 'proup') && !control.deleted) {
              mapTree(control.children)
            } else if (control.type == 'panel' && !control.deleted) {
              for (let chil of control.blockContentList) {
                mapTree(chil.drags)
              }
            }
          }
        }
        mapTree(this.DragList)
      },

      getDeviceByCode(code) {
        let self = this
        return new Promise((resolve, reject) => {
          let dev = this.deviceList.find(item => item.code == code)
          if (dev) {
            resolve(dev)
          } else {
            self.get("/Device/getByCode", {
              code: code
            }).then((res) => {
              if (res.success) {
                resolve(res.result ? res.result : {})
                this.deviceList.push(res.result)
              } else {
                resolve({})
              }
            })
          }
        })
      },
      getPropertyName(devCode, proCode, dev, attr) {
        let self = this;
        return new Promise((resolve, reject) => {
          let product = this.$store.state.productList.find(item => item.id == dev.productId)
          if (product && product.tsl) {
            let propertie = product.tsl.properties.find(item => item.identifier == proCode)
            if (propertie) {
              if (attr) {
                attr.step = propertie.dataType.specs.step
                attr.unit = propertie.dataType.specs.unit
                attr.max = propertie.dataType.specs.max
                attr.min = propertie.dataType.specs.min
                if (propertie.dataType.errorDown || propertie.dataType.errorUp || propertie.dataType.warnDown ||
                  propertie.dataType.warnUp) {
                  attr.errorDown = propertie.dataType.errorDown
                  attr.errorUp = propertie.dataType.errorUp
                  attr.warnDown = propertie.dataType.warnDown
                  attr.warnUp = propertie.dataType.warnUp
                }
              }
              resolve(propertie.name)
            }
          } else {
            self.get("/ProductFeature/getByDeviceCode", {
              code: devCode
            }).then((res) => {
              if (res.success) {
                res.result = JSON.parse(res.result)
                if (res.result.properties) {
                  let pro = res.result.properties.find(pro => pro.identifier == proCode)
                  if (attr) {
                    attr.step = pro.dataType.specs.step
                    attr.unit = pro.dataType.specs.unit
                    attr.max = pro.dataType.specs.max
                    attr.min = pro.dataType.specs.min
                    // console.log(attr)
                    if (pro.dataType.errorDown || pro.dataType.errorUp || pro.dataType.warnDown || pro.dataType
                      .warnUp) {
                      attr.errorDown = pro.dataType.errorDown || '0.02'
                      attr.errorUp = pro.dataType.errorUp || '0.08'
                      attr.warnDown = pro.dataType.warnDown || '0.03'
                      attr.warnUp = pro.dataType.warnUp || '0.07'
                    }
                  }
                  resolve(pro ? pro.name : '')
                } else {
                  resolve('')
                }
              } else {
                resolve('')
              }
            })
          }
        })
      },
      // 获取文本数据
      async getTextData(parmes) {
        // console.log('getTextData')
        let res = await this.getChartsData('/Report/getData2', parmes);
        if (res.result && res.result.data[0] && res.result.data[0].data.length && res.result.data[0].data[0].value) {
          this.textValue = {
            value: res.result.data[0].data[0].value[0]
          }
        } else {
          this.textValue = {
            value:null
          }
        }
      },
      // 初始化图表
      async initCharts(reset, sample = true) {
        let chartDom = document.getElementById("graph" + this.item.id)
        if (!chartDom && !reset && this.item.options) {
          return
        }
        // 图表配置初始化  不包括3d
        if (this.item.type == "graph" && this.item.controlId != 18) {
          let echart = ChartsControlConfigList.find(item => item.controlId == this.item.controlId)
          if (echart) {
            this.item.options = this.clone(echart.options)
            if (this.item.options.legend) {
              this.item.options.legend.show = this.item.legend
              // this.item.options.legend.formatter = ?'{name}':''
              if (this.item.legendTextShow == false) {
                this.item.options.legend.formatter = () => {
                  return ' '
                }
                if (this.item.controlId == 27) {
                  this.item.options.radar.name.formatter = (a, b) => {
                    return `{a|${''}}\n{b}`;
                  }
                }
              } else {
                this.item.options.legend.formatter = '{name}'
              }
            } else if (this.item.controlId == 27) {
              if (this.item.legendTextShow == false) {
                this.item.options.radar.name.formatter = (a, b) => {
                  return `{a}\n{b|8%}`;
                }
              } else {
                this.item.options.radar.name.formatter = (a, b) => {
                  return `{a|${a}}\n{b|8%}`;
                }
              }
            } else if (this.item.controlId == 28) {
              if (this.item.legendTextShow == false) {
                this.item.options.series[0].data[0].title.show = false
              } else {
                this.item.options.series[0].data[0].title.show = true
                this.item.options.series[0].data[0].title.color = this.item.legendColor||null
                this.item.options.series[0].data[0].title.fontSize = Number(this.item.legendSize)||16
                // console.log(this.item.options)
              }
            }
            // 设置Y轴取值范围
            if(this.item.MinY||this.item.MinY==0){
              this.item.options.yAxis.min = this.item.MinY
            }
            if(this.item.MaxY||this.item.MaxY==0){
              this.item.options.yAxis.max = this.item.MaxY
            }
            // y轴样式
            if((this.item.fontSizeY||this.item.fontColorY)&&this.item.options.yAxis){
              this.item.options.yAxis.axisLabel = {
                color:this.item.fontColorY||null,
                fontSize:Number(this.item.fontSizeY)||12
              }
            }
            // x轴样式
            if((this.item.fontSizeX||this.item.fontColorX)&&this.item.options.xAxis){
              this.item.options.xAxis.axisLabel = {
                color:this.item.fontColorX||null,
                fontSize:Number(this.item.fontSizeX)||12
              }
            }
            // 图例字体样式
            if(this.item.legend&&this.item.legendTextShow!=false&&this.item.options.legend){
              this.item.options.legend.textStyle={
                fontSize:Number(this.item.legendSize)||12,
                color:this.item.legendColor||"#afc0d0"
              }
            }
          }
          // 初始化仪表板颜色区域
          if (this.item.controlId == 28) {
            let range = this.item.max - this.item.min,
              max = this.item.max
            let color = []
            let val = Number(((this.item.gaugeMin2 - this.item.min) / range).toFixed(2))
            if (this.item.gaugeMin2 != this.item.min) {
              color.push([val, '#bd4449'])
            }
            val = Number(((this.item.gaugeMin - this.item.min) / range).toFixed(2))
            color.push([val, '#b09b65'])
            val = Number(((this.item.gaugeMax - this.item.min) / range).toFixed(2))
            color.push([val, '#0fdada'])
            val = Number(((this.item.gaugeMax2 - this.item.min) / range).toFixed(2))
            color.push([val, '#b09b65'])
            val = Number(((this.item.gaugeMax2 - this.item.min) / range).toFixed(2))
            color.push([1, '#bd4449'])
            this.item.options.series[0].max = this.item.max
            this.item.options.series[0].min = this.item.min
            this.item.options.series[0].axisLine.lineStyle.color = color
            this.item.options.series[0].axisLabel.formatter = function(value) { //只显示开始结束值
              let i = Number((value / max).toFixed(2))
              if (i == Infinity || i == 0 || i == 0.25 || i == 0.5 || i == 0.75 || i == 1) {
                return value
              } else {
                return ''
              }
            }
          }
          // this.item.options.xAxis.data=null
          // this.item.options.series.forEach((item,i,arr)=>{
          //   arr[i].data=null
          // })
        }
        // 获取数据
        if (this.item.attrList && this.item.attrList.length) {
          let i = 0,
            // screenData = JSONParse(unzip(localStorage.getItem('screen'))),
            screenGroupCode = localStorage.getItem('screenGroupCode'),
            nameArr = [],
            timeArr = []
          // 初始化上期数据数组
          if (this.item.oldData) {
            this.item.oldDataList = []
          }
          // 遍历关联属性获取数据
          for (let i in this.item.attrList) {
            nameArr.push(this.item.attrList[i].name)
            let parmes = {
              frameType: this.item.timeType,
              timeFrameType: this.item.period,
              timeFrameSize: this.item.timeNum,
              timeFrame: this.item.timeUnit,
              timeWindow: this.item.granularityUint,
              timeWindowSize: this.item.granularity,
              beginFrame: this.item.beginFrame,
              endFrame: this.item.endFrame
            }
            // 单个数据的图表需要格式化时间粒度
            if (this.item.controlId == 18 || this.item.controlId == 19 || this.item.controlId == 23 || this.item
              .controlId == 27 || this.item.controlId == 28 ||
              this.item.controlId == 31 || this.item.controlId == 32 || this.item.controlId == 33 || this.item
              .controlId == 35 || this.item.controlId == 37) {
              //自然，相对时段，时间粒度为跨度单位和跨度数
              if (this.item.timeType != 3) {
                parmes.timeWindow = this.item.timeUnit
                parmes.timeWindowSize = this.item.timeNum
              } else {
                // 指定时段，单位固定分，计算跨度内的分钟数
                parmes.timeWindow = 1
                let time = parmes.endFrame - parmes.beginFrame
                // time = parseInt(time / 60000) //获取分
                time = Math.round(time / 60000);
                parmes.timeWindowSize = time
              }
            }
            if(!this.item.attrList[i].data||this.item.timeType != 2||this.item.timeType == 2&&Array.isArray(this.item.attrList[i].data)){
              this.item.attrList[i].data = []
            }
            // 数据集
            if (this.item.attrList[i].type == 1 && this.item.attrList[i].datasetId) {
              parmes.id = this.item.attrList[i].datasetId
              parmes.code = screenGroupCode
              let res = await this.getChartsData("/v2/Dataset/getData", parmes);
              // 数据集存在多个数据，每个数据都需要处理
              if (res.result) {
                if (this.item.type == "ranking") {
                  if (!Array.isArray(this.item.dataSetAttrList)) {
                    this.item.dataSetAttrList = []
                  }
                  // console.log(res.result)
                  for (let attr of res.result) {
                    if (attr.deviceCode && attr.propertyCode) { //函数有设备code和属性code
                      let oldAttr = this.item.dataSetAttrList.find(item => item.deviceCode == attr.deviceCode && item
                        .propertyCode == attr.propertyCode)
                      // 不是第一次格式数据就直接修改数据值，否则需要获取设备名和属性名
                      if (oldAttr) {
                        oldAttr.data = attr.data[0] ? attr.data[0].value : [],
                        oldAttr.type = 1
                      } else {
                        // let newAttr = await this.resetAttr(attr)
                        let dev = this.deviceList.find(devItem => devItem.code == attr.deviceCode)
                        // console.log(dev,attr)
                        if (dev) {
                          attr.deviceName = dev.name
                          attr.data = attr.data[0] ? attr.data[0].value : []
                          attr.type = 1
                          attr.propertyName = await this.getPropertyName(attr.deviceCode, attr.propertyCode, dev)
                          this.item.dataSetAttrList.push(attr)
                        } else {
                          let dev = await this.getDeviceByCode(attr.deviceCode)
                          attr.deviceName = dev.name
                          attr.data = attr.data[0] ? attr.data[0].value : []
                          attr.type = 1
                          attr.propertyName = await this.getPropertyName(attr.deviceCode, attr.propertyCode, dev)
                          this.item.dataSetAttrList.push(attr)
                        }
                      }
                    } else {
                      let oldAttr = this.item.dataSetAttrList.find(item => item.name == attr.name)
                      if (oldAttr) {
                        oldAttr.data = attr.data[0] ? attr.data[0].value : []
                        oldAttr.type = 1
                      } else {
                        attr.data = attr.data[0] ? attr.data[0].value : []
                        attr.type = 1
                        this.item.dataSetAttrList.push(attr)
                      }
                    }
                  }
                } else if (this.item.type == "gradeH") {
                  // console.log(this.item,res.result)
                  var min = Number(this.item.min)||0,range =  Number(this.item.max)- Number(this.item.min)
                  var value = res.result[0] && res.result[0].data && res.result[0].data[0] &&
                    res.result[0].data[0].value ? res.result[0].data[0].value[0] : 0
                  this.$set(this.item, "gradeValue",Math.round((value-min) / range * 100))
                  // console.log(this.item.gradeValue,value)
                } else {
                  for (let result of res.result) {
                    let dev = this.deviceList.find(item => item.code == result.deviceCode)
                    if (dev) {
                      result.deviceName = dev.name
                      result.propertyName = await this.getPropertyName(result.deviceCode, result.propertyCode, dev)
                      result.name = dev.name + '/' + result.propertyName
                    }
                    if (this.item.controlId == 32 || this.item.controlId == 33) { // 百分比仪表盘 水球图
                      this.item.decimal = Number(this.item.decimal)
                      if (res.result[0] && res.result[0].data.length && res.result[0].data[0].value) {
                        this.item.attrList[i].data = [Number(res.result[0].data[0].value[0].toFixed(this.item
                          .controlId == 32 ? this.item.decimal + 2 : this.item.decimal))]
                      } else {
                        this.item.attrList[i].data = [0]
                      }
                    } else {
                      let data = await this.resetData(result,this.item.type=='ranking')
                      result.data = data.dataArr
                      // console.log(result.data)
                      if (this.item.timeType == 2 && result.data.length && this.item.attrList[i].data && this.item
                        .attrList[i].data.data && this.item.attrList[i].data.data.length) {
                        this.item.attrList[i].data.data.splice(0, 1)
                        this.item.attrList[i].data.data.push(result.data[result.data.length - 1])
                      } else {
                        this.item.attrList[i].data.push(result)
                      }
                      if (!timeArr.length) {
                        timeArr = data.timeArr
                      }
                    }
                  }
                }
                // 是否展示上期数据,只处理折线图和柱状图
                if (this.item.oldData && (this.item.controlId == 20 || this.item.controlId == 21 || this.item
                    .controlId == 22 || this.item.controlId == 24 || this.item.controlId == 25)) {
                  // 创建存放上期数据的数组
                  // 修改时间
                  parmes.beginFrame = this.item.oldBeginFrame
                  parmes.endFrame = this.item.oldEndFrame
                  let res2 = await this.getChartsData("/v2/Dataset/getData", parmes);
                  let attr = this.clone(this.item.attrList[i])

                  this.item.attrList[i].data.forEach(item => {
                    item.nickName = '本期-' + item.name
                  })
                  attr.data.forEach(item => {
                    item.nickName = '上期-' + item.name
                  })
                  // this.item.attrList[i].nickName = '本期-'+this.item.attrList[i].name
                  // attr.nickName = '上期-'+attr.name
                  attr.data = []
                  if (res2.result) {
                    for (let result of res2.result) {
                      let dev = this.deviceList.find(item => item.code == result.deviceCode)
                      if (dev) {
                        result.deviceName = dev.name
                        result.propertyName = await this.getPropertyName(result.deviceCode, result.propertyCode, dev)
                        result.name = dev.name + '/' + result.propertyName
                      }
                      let data2 = await this.resetData(result,this.item.type=='ranking')
                      result.data = data2.dataArr
                      attr.data.push(result)
                    }
                    if (!this.item.oldDataList) {
                      this.item.oldDataList = []
                    }
                    this.item.oldDataList.push(attr)
                  } else {
                    if (!this.item.oldDataList) {
                      this.item.oldDataList = []
                    }
                    this.item.oldDataList.push(attr)
                  }
                }
              }
              // 莫名的bug，当前遍历出的item修改后this.item.attrList有时不更新
              // this.item.attrList[i-1]=item
            } else if (this.item.attrList[i].type == 2 && this.item.attrList[i].attrKey) {
              parmes.deviceCode = this.item.attrList[i].attrKey[0]
              parmes.propertyCode = this.item.attrList[i].attrKey[1]
              // 获取数据
              // console.log("获取数据")
              let res = await this.getChartsData('/Report/getData2', parmes);
              if (res.result && res.result.data) {
                if (this.item.controlId == 32 || this.item.controlId == 33) { //百分比仪表盘
                  this.item.decimal = Number(this.item.decimal)
                  if (res.result.data[0] && res.result.data[0].data.length && res.result.data[0].data[0].value && res
                    .result.data[0].data[0].value[0]) {
                    // console.log(res.result.data[0].data[0].value[0])
                    this.item.attrList[i].data = [Number(res.result.data[0].data[0].value[0].toFixed(this.item
                      .controlId == 32 ? this.item.decimal + 2 : this.item.decimal))]
                  } else {
                    this.item.attrList[i].data = [0]
                  }
                } else if (this.item.type == "gradeH") {
                  this.item.decimal = Number(this.item.decimal)
                  // console.log(res)
                  if (res.result.data[0] && res.result.data[0].data.length && res.result.data[0].data[0].value && res
                    .result.data[0].data[0].value[0]) {
                    this.$set(this.item, 'gradeValue', Number(res.result.data[0].data[0].value[0].toFixed(this.item
                      .controlId == 32 ? this.item.decimal + 2 : this.item.decimal)))
                      var min = Number(this.item.min)||0,range =  Number(this.item.max)- Number(this.item.min)
                      var value = res.result.data[0].data[0].value[0]
                      this.$set(this.item, "gradeValue",Math.round((value-min) / range * 100))
                      // console.log(this.item.gradeValue,value)
                  } else {
                    this.$set(this.item, 'gradeValue', 0)
                  }
                } else {
                  let data = await this.resetData(res.result.data[0],this.item.type=='ranking')
                  if (this.item.timeType == 2 && this.item.attrList[i].data&&this.item.attrList[i].data.length && data.dataArr.length) {
                    this.item.attrList[i].data.splice(0, 1)
                    this.item.attrList[i].data.push(data.dataArr[data.dataArr.length - 1])
                  } else {
                    this.item.attrList[i].data = data.dataArr
                  }
                  if (!timeArr.length) {
                    timeArr = data.timeArr
                  }
                }
                // 是否展示上期数据,只处理折线图和柱状图
                if (this.item.oldData && (this.item.controlId == 20 || this.item.controlId == 21 || this.item
                    .controlId == 22 || this.item.controlId == 24 || this.item.controlId == 25)) {
                  // 创建存放上期数据的数组
                  // 修改时间
                  if (!this.item.oldDataList) {
                    this.item.oldDataList = []
                  }
                  parmes.beginFrame = this.item.oldBeginFrame
                  parmes.endFrame = this.item.oldEndFrame
                  // console.log("上期")
                  let res2 = await this.getChartsData("/Report/getData2", parmes);
                  let attr = this.clone(this.item.attrList[i])
                  this.item.attrList[i].nickName = '本期-' + (item.legendText || item.name)
                  attr.nickName = '上期-' + (attr.legendText || attr.name)
                  if (res2.result && res2.result.data) {
                    let data2 = await this.resetData(res2.result.data[0])
                    attr.data = data2.dataArr
                    this.item.oldDataList.push(attr)
                  }
                }
              }
              // 莫名的bug，当前遍历出的item修改后this.item.attrList有时不更新
              // this.item.attrList[i-1]=item
            }
            if (this.item.type != "gradeH"&&this.item.type != "ranking") {
              this.$set(this.item.attrList, i, this.item.attrList[i])
              if (i == this.item.attrList.length - 1) {
                // debugger
                // console.log(this.item.attrList)
                this.initChartsData(timeArr, nameArr, reset, sample)
              }
            }else if(this.item.type == "ranking" && i == this.item.attrList.length - 1){
              this.initChartsData(timeArr, nameArr, reset, sample)
            }
          }
        } else if (this.item.type == "graph" && this.item.controlId != 18) {
          let dom = document.getElementById("graph" + this.item.id)
          if (!dom) {
            return
          }
          if (!dom.clientWidth) {
            return
          }
          dom.removeAttribute('_echarts_instance_')
          let echart = this.$echarts.init(dom)
          // echart.clear()
          echart.setOption(this.item.options, reset)
        }
      },
      // // 同步遍历数据集对象
      // mapAttr(attrList){
      //   if (this.item.dataSetAttrList){
      //     for(let item of this.item.dataSetAttrList){
      //       let obj = attrList.find(a => a.name == item.name)
      //       if(!obj){
      //         attrList.push(item)
      //       }else{
      //         obj.deviceCode = item.deviceCode
      //         obj.propertyCode = item.propertyCode
      //         obj.data = item.data
      //       }
      //     }
      //   }
      //   console.log(attrList)
      // },
      // initChartsData
      async initChartsData(timeArr, nameArr, reset, sample) {
        // item.type==1  数据集=>可能存在多个数据
        console.log("initChartsData")

        try {
          let timeArr2 = []
          timeArr2 = timeArr.map((item) => {
            return this.changeTime(item)
          })
          if (this.item.type == "graph") {
            if (this.item.controlId == 18) { //3d环形图
              let data = [],
                count = 0
              for (let item of this.item.attrList) {
                if (item.type == 1) {
                  let index = 0
                  for (let result of item.data) {
                    count += result && result.data && result.data[0] ? Number(result.data[0]) : 0
                    data.push({
                      name:  item.datasetNameList[index].legendText || result.nickName || result.name,
                      value: result && result.data && result.data[0] ? result.data[0] : 0,
                      unit: this.item.unit,
                      decimal: this.item.decimal
                    })
                    index++
                  }
                } else {
                  count += item.data && item.data[0] ? Number(item.data[0]) : 0
                  data.push({
                    name: item.legendText || item.name,
                    value: item.data && item.data[0] ? item.data[0] : 0,
                    unit: this.item.unit,
                    decimal: this.item.decimal
                  })
                }
              }
              data.forEach(item => {
                item.realityData = item.value
                item.value = item.value ? Number(item.value / count) : item.value
              })
              this.$refs['pie3d' + this.item.id].resetData(data)
              console.log(data)
            } else if (this.item.controlId == 19 || this.item.controlId == 31) { //饼图,基础环图，
              let data = [],
                count = 0
              for (let item of this.item.attrList) {
                if (item.type == 1) {
                  let index = 0
                  for (let result of item.data) {
                    count += result && result.data && result.data[0] ? Number(result.data[0]) : 0
                    data.push({
                      name: item.datasetNameList[index].legendText ||result.nickName || result.name,
                      value: result && result.data && result.data[0] ? result.data[0] : 0,
                      unit: this.item.unit,
                    })
                    index++
                  }
                } else {
                  count += item.data ? Number(item.data[0]) : 0
                  data.push({
                    name: item.legendText ||item.name,
                    value: item.data && item.data[0] ? item.data[0] : 0,
                    unit: this.item.unit
                  })
                }
              }
              data.forEach(item => {
                item.realityData = Number((item.value / count * 100).toFixed(this.item.decimal))
              })
              this.item.options.series[0].data = data
            } else if (this.item.controlId == 20 || this.item.controlId == 21 || this.item.controlId == 22) { //3个折现图
              // this.item.options.xAxis.type="time"
              if (this.item.percentage) { //百分比
                this.item.options.yAxis.max = 100
                this.item.options.yAxis.min = 0
              }
              // 纵横轴刻度
              this.item.options.xAxis.splitNumber = this.item.scaleX
              this.item.options.yAxis.splitNumber = this.item.scaleY
              this.item.options.xAxis.data = timeArr2
              // this.item.options.xAxis.axisLabel.formatter='{MM}-{dd} {hh}:{mm}'
              let series = [],
                attrList = []
              if (this.item.oldData && this.item.oldDataList) {
                attrList = this.item.attrList.concat(this.item.oldDataList)
              } else {
                attrList = this.item.attrList
              }
              for (let i in attrList) {
                let item = attrList[i]
                if (item.type == 1 && item.data) {
                  let index = 0
                  for (let result of item.data) {
                    let obj = this.clone(this.item.options.series[0])
                    obj.unit = this.item.unit,
                      obj.name = item.datasetNameList[index].legendText || result.nickName || result.name,
                      obj.data = result.data ? result.data.map(chi => {
                        return {
                          value: chi,
                          unit: obj.unit
                        }
                      }) : []
                    if (this.item.maximum) {
                      obj.markPoint = {
                        label: {
                          normal: {
                            show: true,
                            backgroundColor: '#2c3e50',
                            position: 'top',
                            color: '#c4e1ff',
                            borderRadius: 2,
                            borderColor: '#2c3e50',
                            borderWidth: 1,
                            padding: 8
                          }
                        },
                        symbol: 'circle',
                        itemStyle: {
                          normal: {
                            borderColor: 'rgba(44,62,95,0.3)',
                            borderWidth: 15
                          }
                        },
                        symbolSize: 7,
                        data: [{
                            type: 'max',
                            name: '最大值'
                          },
                          {
                            type: 'min',
                            name: '最小值'
                          }
                        ]
                      }
                    }
                    if (this.item.percentage) {
                      // 转换百分比数据
                      let max = await this.getMax(obj.data).max
                      obj.max = max || 0
                      obj.data.forEach((item, index, arr) => {
                        if (!arr[index].value) {
                          arr[index].realityData = 0
                          arr[index].value = '-'
                        } else {
                          arr[index].realityData = Number(arr[index].value)
                          arr[index].value = Number((arr[index].value / max * 100).toFixed(2))
                        }
                      })
                    }
                    series.push(obj)
                    index++
                  }
                } else {
                  let obj = this.clone(this.item.options.series[0])
                  obj.unit = this.item.unit,
                    obj.name = item.nickName || item.legendText ||  item.name,
                    obj.data = item.data ? item.data.map(chi => {
                      return {
                        value: chi,
                        unit: obj.unit
                      }
                    }) : []

                  if (this.item.maximum) {
                    obj.markPoint = {
                      label: {
                        normal: {
                          show: true,
                          backgroundColor: '#2c3e50',
                          position: 'top',
                          color: '#c4e1ff',
                          borderRadius: 2,
                          borderColor: '#2c3e50',
                          borderWidth: 1,
                          padding: 8
                        }
                      },
                      symbol: 'circle',
                      itemStyle: {
                        normal: {
                          borderColor: 'rgba(44,62,95,0.3)',
                          borderWidth: 15
                        }
                      },
                      symbolSize: 7,
                      data: [{
                          type: 'max',
                          name: '最大值'
                        },
                        {
                          type: 'min',
                          name: '最小值'
                        }
                      ]
                    }
                  }
                  if (this.item.percentage) {
                    // 转换百分比数据
                    let max = await this.getMax(obj.data).max
                    obj.max = max || 0
                    obj.data.forEach((item, index, arr) => {
                      if (!arr[index].value) {
                        arr[index].realityData = 0
                        arr[index].value = '-'
                      } else {
                        arr[index].realityData = Number(arr[index].value)
                        arr[index].value = Number((arr[index].value / max * 100).toFixed(2))
                      }
                    })
                  }
                  series.push(obj)
                }
              }
              this.item.options.series = series
              this.item.options.tooltip.formatter = data => {
                let html = `
                <p>
                  <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
                  <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
                </p>
                `
                for (let item of data) {
                  let text = `
                  <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
                    <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data.realityData||item.data.realityData==0?item.data.realityData:item.data.value||item.data.value==0?item.data.value:'-'} ${item.data.unit||''}</span>
                  </p>`
                  html += text
                }
                return html
              }
            } else if (this.item.controlId == 24 || this.item.controlId == 25) { //2个柱状图
              // this.item.options.xAxis.type="time"
              this.item.options.xAxis.splitNumber = Number(this.item.scaleX)
              this.item.options.yAxis.splitNumber = Number(this.item.scaleY)
              this.item.options.xAxis.data = timeArr.map((item) => {
                return this.changeTime(item)
              })
              // this.item.options.xAxis.axisLabel.formatter='{MM}-{dd} {hh}:{mm}'
              let series = [],
                attrList = []
              if (this.item.oldData && this.item.oldDataList) {
                attrList = this.item.attrList.concat(this.item.oldDataList)
              } else {
                attrList = this.item.attrList
              }
              // attrList = this.item.attrList
              for (let item of attrList) {
                if (item.type == 1) {
                  let index = 0
                  for (let result of item.data) {
                    let obj = this.clone(this.item.options.series[0])
                    if (series.length) {
                      obj.barGap = -0.1
                    }
                    obj.data = result.data,
                    obj.unit = this.item.unit,
                    obj.name = item.datasetNameList[index].legendText || result.nickName || result.name,
                    series.push(obj)
                    index++
                  }
                } else {
                  let obj = this.clone(this.item.options.series[0])
                  if (series.length) {
                    obj.barGap = -0.1
                  }
                  obj.data = item.data,
                    obj.unit = this.item.unit,
                    obj.name = item.nickName || item.legendText || item.name,
                    series.push(obj)
                }
              }
              this.item.options.series = series
              console.log(series)
              let unit = this.item.unit || ''
              this.item.options.tooltip.formatter = data => {
                let html = `
                <p>
                  <span style="display:inline-block;width: 4px;height: 4px;background: #FFF;border-radius: 50%;position:relative; top:-2px;"></span>
                  <span style="font-size:12px;color:#C4E1FF;font-weight:400;">${data[0].name}</span>
                </p>
                `
                for (let item of data) {
                  let text = `
                  <p style="font-size: 14px;font-family: SHR;font-weight: 400;color: #AFC0D0;line-height: 20px;">${item.seriesName}：
                    <span style="font-size: 18px;font-family: YSBTH;font-weight: 400;color: #5585FF;line-height: 20px;margin-right:5px;">${item.data} ${unit}</span>
                  </p>`
                  html += text
                }
                return html
              }

            } else if (this.item.controlId == 26) { //散点图
              this.item.options.xAxis.splitNumber = 5
              let data = []
              this.item.options.series[0].name = this.item.controlName
              if (this.item.attrList[0].data && this.item.attrList[1].data) {
                for (let i in this.item.attrList[0].data) {
                  let arr = [this.item.attrList[0].data[i], this.item.attrList[1].data[i]]
                  data.push(arr)
                }
              }
              this.item.options.series[0].data = data
              // console.log(this.item.options)
            } else if (this.item.controlId == 27) { //雷达图
              let data = [],
                indicator = []
              for (let item of this.item.attrList) {
                let ind = {
                  text: item.legendText || item.name,
                  max: item.max,
                  min: item.min
                }
                indicator.push(ind)
                data.push(item.data ? item.data[0] : 0)
              }
              this.item.options.series.data[0].value = data
              this.item.options.radar.indicator = indicator
              this.item.options.index = -1
              if (this.item.legendTextShow == false) {
                this.item.options.radar.name.formatter = (a, b) => {
                  this.item.options.index++
                  return `{a|${''}}\n{b|${data[this.item.options.index]||0}${this.item.unit||''}}`;
                }
              } else {
                this.item.options.radar.name.formatter = (a, b) => {
                  this.item.options.index++
                  return `{a|${a||''}}\n{b|${data[this.item.options.index]||0}${this.item.unit||''}}`;
                }
              }
              this.item.options.radar.name.rich.a={
                fontSize: Number(this.item.legendSize)||'14',
                color: this.item.legendColor||'#ffffff',
                lineHeight: '20'
              }
            } else if (this.item.controlId == 28 && this.item.attrList[0]) { //仪表盘
              if (this.item.decimal || this.item.decimal == 0) {
                this.item.options.series[0].detail.formatter = (value) => {
                  let text = value.toFixed(this.item.decimal)
                  if (isNaN(text)) {
                    return 0
                  } else {
                    return text
                  }
                }
              }
              let data = {
                value: this.item.attrList[0].data ? this.item.attrList[0].data[0] : 0,
                name: this.item.attrList[0].legendText || this.item.attrList[0].name,
                title: {
                  show: this.item.legendTextShow == false ? false : true,
                  color: this.item.legendColor||"#fff",
                  fontSize: Number(this.item.legendSize)||16,
                  fontFamily: "YSBTH",
                }
              }
              this.item.options.series[0].data[0] = data
            } else if (this.item.controlId == 32) { //百分比仪表盘
              let color = [],
                val = this.item.attrList[0].data[0]
              this.item.options.graphic[0].style.text = val * 100 + "%"
              this.item.options.graphic[1].style.text = this.item.attrList[0].legendText || this.item.attrList[0].name
              if (val > 0) {
                if (val < 0.2) {
                  this.item.options.series[0].splitNumber = 1
                } else if (val < 0.4) {
                  this.item.options.series[0].splitNumber = 2
                } else if (val < 0.6) {
                  this.item.options.series[0].splitNumber = 4
                } else if (val < 0.75) {
                  this.item.options.series[0].splitNumber = 6
                } else if (val > 0.75) {
                  this.item.options.series[0].splitNumber = 8
                }
                if (val <= 0.25) {
                  color = [
                    [val, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#02d2e9',
                      },
                    ], false)],
                  ]
                } else if (val <= 0.5) {
                  color = [
                    [0.25, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#02d2e9',
                      },
                    ], false)],
                    [val, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [

                      {
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#9aff36',
                      },
                    ], false)],
                  ]
                } else if (val < 0.75) {
                  color = [
                    [0.25, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#02d2e9',
                      },
                    ], false)],
                    [0.5, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [

                      {
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#9aff36',
                      },
                    ], false)],
                    [val, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#9aff36',
                      },
                      {
                        offset: 1,
                        color: '#f5ce07',
                      },
                    ], false)],
                  ]
                } else if (val > 0.75) {
                  color = [
                    [0.25, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#02d2e9',
                      },
                    ], false)],
                    [0.5, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [

                      {
                        offset: 0,
                        color: '#3ef286',
                      },
                      {
                        offset: 1,
                        color: '#9aff36',
                      },
                    ], false)],
                    [0.75, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#9aff36',
                      },
                      {
                        offset: 1,
                        color: '#f5ce07',
                      },
                    ], false)],
                    [val, new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                        offset: 0,
                        color: '#f74141',
                      },
                      {
                        offset: 1,
                        color: '#f5ce07',
                      },
                    ], false)]
                  ]
                }
              }
              this.item.options.series[0].axisLine.lineStyle.color = color
            } else if (this.item.controlId == 33) { //水球图
              this.item.options.series[0].data[0].name = this.item.attrList[0].legendText || this.item.attrList[0].name
              this.item.options.series[0].data[1].name = this.item.attrList[0].legendText || this.item.attrList[0].name
              this.item.options.series[0].data[0].unit = this.item.unit
              this.item.options.series[0].data[1].unit = this.item.unit
              this.item.options.series[0].data[0].value = this.item.attrList[0].data ? this.item.attrList[0].data[0] :
                0
              this.item.options.series[0].data[1].value = this.item.attrList[0].data ? this.item.attrList[0].data[0] :
                0
              this.item.options.series[0].data[0].realityData = this.item.attrList[0].data ? this.item.attrList[0]
                .data[0] : 0
              this.item.options.series[0].data[1].realityData = this.item.attrList[0].data ? this.item.attrList[0]
                .data[0] : 0
              if ((this.item.min == 0 || this.item.min) && (this.item.max == 0 || this.item.max)) {
                let rannge, max = this.item.max,
                  min = this.item.min,
                  realityData = this.item.options.series[0].data[0].realityData
                if (max < 0) {
                  rannge = Math.abs(min) - Math.abs(max)
                } else {
                  rannge = max - min
                }
                let value = (realityData / rannge).toFixed(2)
                this.item.options.series[0].data[0].value = value
                this.item.options.series[0].data[1].value = value
              }
              let realityData = this.item.options.series[0].data[0].realityData
              if (realityData >= Number(this.item.gaugeMax) || realityData <= Number(this.item.gaugeMin)) {
                this.item.options.series[0].data[0].itemStyle.color.colorStops = [{
                  offset: 1,
                  color: 'rgba(183, 15, 76, .1)',
                }, {
                  offset: 0.5,
                  color: 'rgba(183, 15, 76, .5)',
                }, {
                  offset: 0,
                  color: 'rgba(183, 15, 76, 1)',
                }]
                this.item.options.series[0].data[1].itemStyle.color.colorStops = [{
                  offset: 1,
                  color: 'rgba(183, 15, 76, .1)',
                }, {
                  offset: 0.5,
                  color: 'rgba(183, 15, 76, .3)',
                }, {
                  offset: 0,
                  color: 'rgba(183, 15, 76, .3)',
                }]
                this.item.options.series[0].data[0].color = "#b70f4c"
                this.item.options.series[0].data[1].color = "#b70f4c"
                this.item.options.series[0].backgroundStyle.borderColor = 'rgba(183, 15, 76, 1)'
                this.item.options.series[0].backgroundStyle.shadowColor = 'rgba(183, 15, 76, 1)'
                this.item.options.series[0].outline.itemStyle.borderColor = 'rgba(183, 15, 76, 1)'
                this.item.options.series[0].outline.itemStyle.shadowColor = 'rgba(183, 15, 76, 1)'
                this.item.warning = true
              } else {
                this.item.options.series[0].data[0].itemStyle.color.colorStops = [{
                  offset: 1,
                  color: 'rgba(11, 186, 219, .1)',
                }, {
                  offset: 0.5,
                  color: 'rgba(11, 186, 219, .5)'
                }, {
                  offset: 0,
                  color: 'rgba(11, 186, 219, 1)',
                }]
                this.item.options.series[0].data[1].itemStyle.color.colorStops = [{
                  offset: 1,
                  color: 'rgba(11, 186, 219, .1)',
                }, {
                  offset: 0.5,
                  color: 'rgba(11, 186, 219, .3)',
                }, {
                  offset: 0,
                  color: 'rgba(11, 186, 219, .3)',
                }]
                this.item.options.series[0].data[0].color = "#0bbadb"
                this.item.options.series[0].data[1].color = "#0bbadb"
                this.item.options.series[0].backgroundStyle.borderColor = 'rgba(11, 186, 219, 1)'
                this.item.options.series[0].backgroundStyle.shadowColor = 'rgba(11, 186, 219, 1)'
                this.item.options.series[0].outline.itemStyle.borderColor = 'rgba(11, 186, 219, 1)'
                this.item.options.series[0].outline.itemStyle.shadowColor = 'rgba(11, 186, 219, 1)'
                this.item.warning = false
              }
            } else if (this.item.controlId == 35) {
              this.item.options.series[0].splitNumber = 100
              var self = this
              var min = Number(this.item.min)||0
              var max = Number(this.item.max)||100
              var range = max - min
              var range1 = Math.round((Number(this.item.range1)-min)/range * 100)||25
              var range2 = Math.round((Number(this.item.range2)-min)/range * 100)||50
              var range3 = Math.round((Number(this.item.range3)-min)/range * 100)||75
              // 计算文字位置
              var chaPosition = Math.round(range1 / 2)  // 差
              var zhongPosition = Math.round((range2 - range1) / 2) + range1  // 中
              var liangPosition = Math.round((range3 - range2) / 2) + range2  // 良
              var youPosition = Math.round((100 - range3) / 2) + range3  // 优
              this.item.options.series[0].axisLabel.formatter = function (value) {
                  if (value === chaPosition) {
                      return self.item.text1||'差';
                  } else if (value === zhongPosition) {
                      return self.item.text2||'中';
                  } else if (value === liangPosition) {
                      return self.item.text3||'良';
                  } else if (value === youPosition) {
                      return self.item.text4||'优';
                  }
                  return '';
              }
              this.item.options.series[0].detail.formatter = function (value) {
                  if (value <=range1) {
                      return self.item.text1||'差';
                  } else if (value <=range2) {
                      return self.item.text2||'中';
                  } else if (value <=range3) {
                      return self.item.text3||'良';
                  } else if (value > range3) {
                      return self.item.text4||'优';
                  }
                  return '';
              }
              this.item.options.series[0].axisLine.lineStyle.color=[
                [range1/100, this.item.color1],
                [range2/100, this.item.color2],
                [range3/100, this.item.color3],
                [1, this.item.color4]
              ]

              this.item.options.series[0].data[0].unit = this.item.unit || ''
              var value = this.item.attrList[0].data && this.item.attrList[0].data[
                0] && this.item.attrList[0].data[0] != '-' ? this.item.attrList[0].data[0] : 0
                
              if(typeof value == 'object'&&value.data){
                value = Array.isArray(value.data)?value.data[0]:0
              }
              this.item.options.series[0].data[0].value = Math.round((value-min) / range * 100)
              this.item.options.series[0].data[0].name = (this.item.attrList[0].legendText || this.item.attrList[0].name) + ": " + value + this.item.options.series[0].data[0].unit
            }
            // 数据点抽样
            if (this.item.dataNum && this.item.options.xAxis.data && this.item.options.xAxis.data.length && sample) {
              let chunkSize = Math.round(this.item.options.xAxis.data.length / this.item.dataNum)
              let xAxisData = [],
                index = 0;
              for (let i in this.item.options.xAxis.data) {
                if (i == index && xAxisData.length < this.item.dataNum) {
                  index += chunkSize
                  xAxisData.push(this.item.options.xAxis.data[i])
                }
              }
              this.item.options.xAxis.data = xAxisData
              for (let series of this.item.options.series) {
                let data = [],
                  resultArr = []
                for (let i = 0; i < series.data.length; i += chunkSize) {
                  resultArr.push(series.data.slice(i, i + chunkSize));
                }
                for (let resultItem of resultArr) {
                  // console.log(resultItem)
                  let dataItem = null;
                  for (let i = resultItem.length - 1; i >= 0; i--) {
                    if (resultItem[i].value != '-' && !dataItem) {
                      dataItem = resultItem[i]
                    }
                  }
                  data.push(dataItem || resultItem[0])
                }
                series.data = data
                // console.log(data)
              }
            }
            // 渲染图形
            if (this.item.controlId != 18) {
              if (this.item.controlId != 32) {
                this.item.options.color = chartsColorOptions.baseColor
              }
              if (this.item.controlId == 20 && this.item.options.series.length) {
                let colors = chartsColorOptions.lineColor
                for (let i in this.item.options.series) {
                  if (colors[i]) {
                    let color = {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 1,
                      y2: 1,
                      colorStops: [{
                        offset: 1,
                        color: colors[i][0] // 0% 处的颜色
                      }, {
                        offset: 0,
                        color: colors[i][1] // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                    }
                    this.item.options.series[i].itemStyle.color = color
                  }
                }
              }

              let dom = document.getElementById("graph" + this.item.id)
              if (!dom) {
                return
              }
              if (!dom.clientWidth) {
                return
              }
              // dom.removeAttribute('_echarts_instance_')
              let echart = this.$echarts.getInstanceByDom(dom)
              if (!echart) {
                echart = this.$echarts.init(dom)
              }
              if (this.item.options.legend) {
                this.item.options.legend.show = this.item.legend
              }

              // echart.clear()
              echart.setOption(this.item.options, reset)
            }

            this.$forceUpdate()
          } else if (this.item.type == "ranking") {
            let arr = [],
              max = '-',
              min = '-',
              index = 0
            let attrList = this.clone(this.item.attrList)
            if (this.item.dataSetAttrList) {
              for (let item of this.item.dataSetAttrList) {
                let obj = attrList.find(a => a.name == item.name && a.deviceCode == item.deviceCode && a
                  .propertyCode == item.propertyCode)
                if (!obj) {
                  attrList.push(item)
                } else {
                  obj.deviceCode = item.deviceCode
                  obj.propertyCode = item.propertyCode
                  obj.data = item.data
                }
              }
            }
            // await this.mapAttr(attrList)
            // console.log(attrList)
            for (let item of attrList) {
              index++
              if (item.type == 2 && item.attrKey) {
                let dev = this.deviceList.find(devItem => devItem.code == item.attrKey[0])
                if (dev && dev.attrDataList) {
                  let attr = dev.attrDataList.find(attr => attr.identifier == item.attrKey[1])
                  if (attr) {
                    item.name = dev.name + '/' + attr.name
                  }
                }
                let obj = {
                  name: item.legendText || item.name,
                  max: 100,
                  min: 0,
                  realityData: item.data ? Number(item.data[0]) : '-',
                  barWidth: 0,
                  id: item.attrKey[0] + item.attrKey[1]
                }
                if (obj.realityData != '-') {
                  if (max == '-' || max < obj.realityData) {
                    max = obj.realityData
                  }
                  if (min == '-' || min > obj.realityData) {
                    min = obj.realityData
                  }
                }
                arr.push(obj)
              } else if (item.type == 1) {
                if (item.propertyCode) {
                  let obj = {
                    name: item.propertyName ? item.propertyName + '/' + item.deviceName : item.propertyCode + '/' +
                      item.deviceName,
                    max: 100,
                    min: 0,
                    realityData: item.data&&item.data.length ? Number(item.data[0]) : '-',
                    barWidth: 0,
                    id: item.deviceCode + item.propertyCode + index
                  }
                  if (obj.realityData != '-') {
                    if (max == '-' || max < obj.realityData) {
                      max = obj.realityData
                    }
                    if (min == '-' || min > obj.realityData) {
                      min = obj.realityData
                    }
                  }
                  arr.push(obj)
                } else {
                  let obj = {
                    name: item.name,
                    max: 100,
                    min: 0,
                    realityData: item.data&&item.data.length ? Number(item.data[0]) : '-',
                    barWidth: 0,
                    id: item.datasetId + index
                  }
                  if (obj.realityData != '-') {
                    if (max == '-' || max < obj.realityData) {
                      max = obj.realityData
                    }
                    if (min == '-' || min > obj.realityData) {
                      min = obj.realityData
                    }
                  }
                  arr.push(obj)
                }
              }
            }
            arr.sort((a, b) => {
              return ((b.realityData < a.realityData || b.realityData == '-' || (!b.realityData && b
                .realityData != 0)) ? -1 : (b.realityData > a.realityData) ? 1 : 0)
            })
            if (arr.length) {
              if (max != '-' && min != '-') {
                max += Math.abs(max * 0.1), min -= Math.abs(min * 0.1)
                for (let i in arr) {
                  if (arr[i].realityData < 0) {
                    arr[i].barWidth = ((Math.abs(Math.abs(arr[i].realityData) + min)) / (max - min) * 100).toFixed(2)
                  } else if (arr[i].realityData == 0) {
                    arr[i].barWidth = ((arr[i].realityData - min) / (max - min) * 100).toFixed(2)
                  } else if (arr[i].realityData > 0) {
                    arr[i].barWidth = ((arr[i].realityData - min) / (max - min) * 100).toFixed(2)
                  }
                }
              }
              // console.log(max,min,arr)
              this.items = arr
            }
          }
        } catch (err) {
          console.error(err, this.items)
        }
      },
      getMax(arr) {
        if (arr.length == 0) {
          return {
            max: 0,
            min: 0
          }
        }
        var max = arr[0].value == '-' ? 0 : arr[0].value;
        var min = arr[0].value == '-' ? 0 : arr[0].value;
        for (var i = 1; i < arr.length; i++) {
          if (arr[i].value || arr[i].value == 0) {
            if (!max && max != 0) max = arr[i].value;
            if (!min && min != 0) min = arr[i].value;
            if (max < arr[i].value) max = arr[i].value;
            if (min > arr[i].value) min = arr[i].value;
          }
        }
        return {
          max: max,
          min: min
        }
      },
      // 获取数据集或者设备属性数据
      getChartsData(url, parmes) {
        let self = this;
        return new Promise((resolve, reject) => {
          // resolve({})
          // return
          // 指定时段没有选择开始/结束时间或者相对/自然时段没有输入时间值或者时间粒度不合理则不请求直接返回一个对象
          if (parmes.frameType == 3 && (!parmes.beginFrame || !parmes.endFrame) || parmes.frameType != 3 && !
            parmes.timeWindowSize && [20, 21, 22, 24, 25, 26].includes(this.item.controlId) || this.item.errTime
          ) {
            resolve({})
          } else {
            self.get(url, parmes).then((res) => {
              if (res.success == true) {
                resolve(res)
              } else {
                resolve({})
              }
            })
          }

        })
      },
      resetData(data,replaceNull) {
        let place = this.item.decimal
        return new Promise((resolve, reject) => {
          if (data.data.length) {
            data.data.sort((a, b) => {
              return a.time - b.time
            })
            let dataArr = [],
              timeArr = []
            for (let item of data.data) {
              if(replaceNull&&(item.value[0] || item.value[0] == 0)){
                dataArr.push(item.value[0] || item.value[0] == 0 ? Number(item.value[0]).toFixed(place) : '-')
                timeArr.push(item.time)
              }else if(!replaceNull){
                dataArr.push(item.value[0] || item.value[0] == 0 ? Number(item.value[0]).toFixed(place) : '-')
                timeArr.push(item.time)
              }
            }
            // console.log(data,place,dataArr)
            resolve({
              dataArr: dataArr,
              timeArr: timeArr
            })
          } else {
            resolve({
              dataArr: [],
              timeArr: []
            })
          }
        })
      },
      //交互
      clickControl(e) {
        if (this.$store.state.Processing) {
          return
        }
        if (this.item.interactiveList && this.item.interactiveList.length) {
          console.log("clickControl")
          e.stopPropagation()
          this.$store.state.Processing = true
          let Processing = false
          // console.log(this.item.interactiveList)
          for (let item of this.item.interactiveList) {
            switch (item.type) {
              case 1:
                if (!item.panelBlock) {
                  this.$store.state.Processing = false
                  return
                }
                this.changePanel(item);
                Processing = true
                break;
              case 2:
                if (!item.DeviceCode) {
                  this.$store.state.Processing = false
                  return
                }
                this.showDataBlock(item);
                Processing = true
                break;
              case 3:
                if (!item.sourceStatus && item.sourceStatus != 0) {
                  this.$store.state.Processing = false
                  return
                }
                this.changeStatus(item);
                if (!Processing) {
                  this.$store.state.Processing = false
                }
                break;
              case 4:
                this.changeValue(item);
                if (!Processing) {
                  this.$store.state.Processing = false
                }
                break;
              case 5:
                this.$store.state.showProupId = this.$store.state.showProupId ? null : item.panelId
                this.$store.state.Processing = false
                if (this.$store.state.showProupId) {
                  this.$nextTick(() => {
                    this.updateProup(this.$store.state.showProupId)
                  })
                }
                // console.log(this.$store.state.showProupId)
                break;
            }
          }
        } else if ((this.item.type == 'image' || this.item.type == 'control' || this.item.type == 'rectangle' || this
            .item.type == 'circular') && this.item.DeviceCode && this.item.DeviceId && this.item.DeviceName) {
          this.$store.state.Processing = true
          this.showDataBlock(this.item);
        }
      },
      // 打开弹窗 子组件(图表)刷新
      updateProup(id) {
        // console.log(id)
        let self = this
        // 更新动态面板里显示的图表
        var mapPanel = async function(panel) {
          let block = panel.blockContentList.find(block => block.id == panel.activeBlock)
          if (block) {
            block.drags.forEach(control => {
              if (control.id == id && control.deleted != true) {
                control.children.forEach(item => {
                  if (item.type == 'graph' && item.controlId != 18 && item.deleted != true) {
                    initChart(item)
                  }
                })
              } else if ((control.type == "makeUp" || control.type == 'proup') && control.deleted != true) {
                mapMakeUp(control)
              } else if (control.type == 'panel' && control.deleted != true) {
                mapPanel(control)
              }
            })
          }
        }

        // 更新组合里的图表
        var mapMakeUp = async function(makeUp) {
          makeUp.children.forEach(chil => {
            if (chil.id == id && chil.deleted != true) {
              chil.children.forEach(item => {
                if (item.type == 'graph' && item.controlId != 18 && item.deleted != true) {
                  initChart(item)
                }
              })
            } else if ((chil.type == 'makeUp' || chil.type == 'proup') && chil.deleted != true) {
              mapMakeUp(chil)
            } else if (chil.type == 'panel' && chil.deleted != true) {
              mapPanel(chil)
            }
          })
        }
        var mapTree = async function(arr = []) {
          for (let control of arr) {
            if (control.id == id && control.deleted != true) {
              control.children.forEach(item => {
                if (item.type == 'graph' && item.controlId != 18 && item.deleted != true) {
                  initChart(item)
                }
              })
            } else if (control.type == "panel" && control.deleted != true) {
              mapPanel(control)
            } else if (control.type == "makeUp" && control.deleted != true) {
              mapMakeUp(control)
            }
          }
        }

        var initChart = async function(control) {
          let dom = document.getElementById("graph" + control.id)
          if (!dom) {
            return
          }
          if (!dom.clientWidth) {
            return
          }
          // dom.removeAttribute('_echarts_instance_')
          try {
            if (dom) {
              // console.log("setOption", control.options)
              let echart = self.$echarts.getInstanceByDom(dom)
              // echart.clear()
              if (!echart) {
                echart = self.$echarts.init(dom)
              }
              echart.setOption(control.options)
              echart.resize();
              self.$forceUpdate()
            }
          } catch (e) {
            console.error(e)
          }
        }
        mapTree(this.DragList)
      },
      changePanelBlock(data){
        // console.log(data.data)
        if(data.data.name=="1#冷水机组"){
          if(this.item.interactiveList[0]&&this.item.interactiveList[0].panelBlock){
            this.changePanel(this.item.interactiveList[0])
          }
        }else if(data.data.name=="2#冷水机组"){
          if(this.item.interactiveList[1]&&this.item.interactiveList[1].panelBlock){
            this.changePanel(this.item.interactiveList[1])
          }
        }else if(data.data.name=="3#冷水机组"){
          if(this.item.interactiveList[2]&&this.item.interactiveList[2].panelBlock){
            this.changePanel(this.item.interactiveList[2])
          }
        }
      },
      // 修改面板状态
      changePanel(item) {
        // let panel = this.DragList.find(drag=>drag.id==item.panelId)
        // if(panel){
        //   panel.activeBlock = item.panelBlock
        //   for(let block of panel.blockList){
        //     if(block.value == item.panelBlock){
        //       panel.activeBlockName = block.name
        //     }
        //   }
        // }
        // console.log("changePanel")
        let self = this
        // 更新动态面板里显示的图表
        var mapPanel = async function(panel) {
          let block = panel.blockContentList.find(block => block.id == panel.activeBlock)
          if (block) {
            block.drags.forEach(control => {
              if (control.type == 'graph' && control.controlId != 18 && control.deleted != true && control.options) {
                // self.$nextTick(()=>{
                // console.log('-------------')
                // let dom = document.getElementById("graph" + control.id)
                // if (!dom) {
                //   return
                // }
                // if (!dom.clientWidth) {
                //   return
                // }
                // if (dom) {
                //     // console.log(dom)
                //     // dom.removeAttribute('_echarts_instance_')
                //       // console.log("setOption", control.options)
                //       let echart = self.$echarts.getInstanceByDom(dom)
                //       // echart.clear()
                //       if (!echart) {
                //         echart = self.$echarts.init(dom)
                //       }
                //       echart.setOption(control.options)
                //       echart.resize();
                //       self.$forceUpdate()
                // }
                // })
              } else if ((control.type == "makeUp" || control.type == 'proup') && control.deleted != true) {
                mapMakeUp(control)
              } else if (control.type == 'panel' && control.deleted != true) {
                mapPanel(control)
              }
            })
          }
        }
        // 更新组合里的图表
        var mapMakeUp = async function(makeUp) {
          makeUp.children.forEach(chil => {
            if (chil.type == 'graph' && chil.controlId != 18 && chil.deleted != true) {
              // self.$nextTick(()=>{
              // console.log(control)
              // let dom = document.getElementById("graph" + chil.id)
              // if (!dom) {
              //   return
              // }
              // if (!dom.clientWidth) {
              //   return
              // }
              // // dom.removeAttribute('_echarts_instance_')
              // // console.log(dom)
              // if (dom) {
              //     let echart = self.$echarts.getInstanceByDom(dom)
              //     // echart.clear()
              //     if (!echart) {
              //       echart = self.$echarts.init(dom)
              //     }
              //     echart.setOption(chil.options)
              //     echart.resize();
              //     self.$forceUpdate()
              // }
              // })
            } else if ((chil.type == 'makeUp' || chil.type == 'proup') && chil.deleted != true) {
              mapMakeUp(chil)
            } else if (chil.type == 'panel' && chil.deleted != true) {
              mapPanel(chil)
            }
          })
        }
        var mapTree = async function(arr = []) {
          for (let panel of arr) {
            if (panel.id == item.panelId && panel.type == 'panel') {
              // return
              // echarts 更新
              let oldVal = panel.activeBlock
              panel.activeBlock = item.panelBlock
              // setTimeout(()=>{

              // })
              if (oldVal != item.panelBlock) {
                // console.log("update view")
                let block = panel.blockContentList.find(block => block.id == item.panelBlock)
                if (block) {
                  for (let block of panel.blockList) {
                    if (block.value == item.panelBlock) {
                      panel.activeBlockName = block.name
                    }
                  }
                  var timer = setTimeout(() => {
                    block.drags.forEach(control => {
                      if (control.type == 'graph' && control.controlId != 18 && control.deleted != true) {
                        // self.$nextTick(() => {
                        // console.log('-------------')
                        // console.log(control)
                        // let dom = document.getElementById("graph" + control.id)
                        // if (!dom) {
                        //   return
                        // }
                        // if (!dom.clientWidth) {
                        //   return
                        // }
                        // // dom.removeAttribute('_echarts_instance_')
                        // try{
                        //   if (dom) {
                        //       // console.log("setOption", control.options)
                        //       let echart = self.$echarts.getInstanceByDom(dom)
                        //       // echart.clear()
                        //       if (!echart) {
                        //         echart = self.$echarts.init(dom)
                        //       }
                        //       echart.setOption(control.options)
                        //       echart.resize();
                        //       self.$forceUpdate()
                        //   }
                        // }catch(e){
                        //   // console.error(e)
                        // }
                        // })
                      } else if ((control.type == "makeUp" || control.type == 'proup') && control.deleted !=
                        true) {
                        mapMakeUp(control)
                      } else if (control.type == 'panel' && control.deleted != true) {
                        mapPanel(control)
                      }
                    })
                    clearTimeout(timer)
                  }, 500)
                }
              }
              self.$store.state.Processing = false
            } else if (panel.type == 'makeUp' || panel.type == 'proup') {
              mapTree(panel.children)
            } else if (panel.type == 'panel') {
              for (let chil of panel.blockContentList) {
                mapTree(chil.drags)
              }
            }
          }
        }
        mapTree(this.DragList)
      },
      changeStatus(item) {
        let source = this.DragList.find(drag => drag.id == item.sourceId)
        if (source) {
          // console.log(source)
          source.url = source['image' + item.sourceStatus]
        }
      },
      changeValue(item) {
        // 权限判断
        if (!this.$store.state.functionList.includes('companyServiceContrl')) {
          this.$message({
            type: 'info',
            message: "该用户没有下发指令权限",
            duration: 10000
          })
          return
        }
        // 验证码提权
        let VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
        if (VerifyArr.includes(12)) {
          this.showRoot()
          return
        }
        if (item.attrCode && item.ManualInput) {
          this.$store.state.ManualInputObj = this.clone(item)
          this.$store.state.showManualInput = true
        } else if (item.attrCode && (item.attrVal || item.attrVal == 0) && !this.loadingShow) {
          this.loadingShow = true
          let data = {
            deviceCode: item.attrCode[0],
            property: item.attrCode[1],
            value: item.attrVal
          }
          this.post('/Device/setPropertyValue', data).then(res => {
            this.loadingShow = false
            if (res.success) {
              // setTimeout(()=>{
              // loading.close()
              this.$message({
                type: 'success',
                message: "指令下发成功"
              })
              // },1000)
            } else {
              // loading.close()
              this.$message({
                type: 'warning',
                message: "指令下发失败：" + res.message
              })
            }
          })
        }
      },
      // 交互动作 - 打开设备属性面板
      showDataBlock(item) {
        // console.log('showDataBlock',item)
        this.$emit('showDataBlock', item)
      },
      showRoot() {
        this.$emit('showRoot')
      },
      getTime(time) {
        var h = time.getHours()
        var m = time.getMinutes()
        var s = time.getSeconds()
        if (h < 10) {
          h = "0" + h
        }
        if (m < 10) {
          m = "0" + m
        }
        if (s < 10) {
          s = "0" + s
        }
        return `${h}:${m}:${s}`
      },
      // 由组合控件和动态面板控件emit触发的事件传递
      // showData(item){
      //   console.log('showData',item)
      //   this.$emit('showDataBlock',item)
      // },
    },
    watch: {
      // "item.timeVal": {
      //   handler(oldValue, newValue) {
      //     // console.log("item.timeVal",oldValue,newValue)
      //     deep: true
      //   }
      // },
      altDown() {
        if (this.altDown) {
          this.$forceUpdate()
        }
      },
      calendarValue(oldTime, newTime) {
        this.item.calendarValue = this.calendarValue
        let oldM = oldTime.getMonth(),
          newM = newTime.getMonth()
        if (oldM != newM) {
          this.getCalendarData()
        }
        if (oldTime.getTime() != newTime.getTime()) {
          this.changeDate2()
        }
      },
      changTimeObj() {
        if (this.item.chartsTimeId == this.changTimeObj.id) {
          if (this.item.type == "textSpan" && this.item.DeviceAttr) {
            this.resetTextTime()
          } else {
            this.resetTime()
          }
        }
      },
    }
  }
</script>
<style scoped lang="scss">
  .deviceAttrBlock {
    position: absolute;
    border: 1px solid #2378df;
    border-radius: 4px;
    width: 160px;
    z-index: 9;

    .block-top {
      background-color: #2378df;
      color: #fff;
      font-size: 14px;
      line-height: 26px;
    }

    .block-value {
      color: #fff;
      font-size: 12px;
      line-height: 26px;
      text-align: left;
      padding: 0 4px;
      box-sizing: border-box;
    }

    &::before {
      position: absolute;
      bottom: -18px;
      content: '';
      display: block;
      left: 50%;
      width: 3px;
      height: 3px;
      margin-left: -1.5px;
      border-radius: 50%;
      background-color: #2378df;
    }

    &::after {
      position: absolute;
      bottom: -15px;
      content: '';
      display: block;
      left: 50%;
      width: 1px;
      height: 15px;
      background-color: #2378df;
    }
  }

  .p-a {
    position: absolute;
  }

  .panelMask {
    background-color: rgba(200, 200, 200, .2);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    &.transparent {
      background-color: transparent;
    }
  }

  .drag {
    border: 1px solid transparent;
  }

  .drag:not(.disabled):hover {
    border: 1px solid #2378df;
  }

  .vdr-border:not(.disabled) {
    border: 1px solid #2378df;

    .conduit {
      img {
        z-index: -1;
        position: absolute;
      }
    }
  }

  .chart-bg-blue {
    background: url("../../assets/image/indexEditor/model7/water2.png") no-repeat;
    background-size: 100%;
    background-position: calc(50% + 2px) calc(50%);
  }

  .chart-bg-red {
    background: url("../../assets/image/indexEditor/model7/water1.png") no-repeat;
    background-size: 100%;
    background-position: calc(50% + 2px) calc(50%);
  }

  .pie {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    position: relative;
    box-sizing: border-box;

    .pie-chart {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      position: absolute;
      background: url("../../assets/editor-icon/pie-bg.png") no-repeat;
      background-size: 55%;
      background-position: calc(50% - 2px) calc(50% + 2px);
    }

    .top {
      font-size: 16px;
      font-family: SHR;
      font-weight: 400;
      text-align: center;
      color: #AFC0D0;
      padding-top: 3%;

      .dian {
        width: 5px;
        height: 5px;
        margin-right: 5px;
        display: inline-block;
        background: #10DCDC;
        border-radius: 50%;
        position: relative;
        top: -5px;
      }

      .num {
        padding-left: 10%;
        box-sizing: border-box;
        font-size: 20px;
        font-family: YSBTH;
        font-weight: 400;
        color: #0FDADA;
      }
    }
  }

  .vdr-border {
    .conduit {
      img {
        z-index: -1;
        position: absolute;
      }
    }
  }

  .text-span {
    display: inline-block;
    padding: 4px 10px;
    background: rgba(80, 80, 80, .8);
    border-radius: 5px;
    letter-spacing: 1px;
    text-align: center;
    white-space: nowrap;
    box-sizing: border-box;
    user-select: none;
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
  }

  .attr-span {
    display: inline-block;
    padding: 4px 10px;
    background: rgba(80, 80, 80, .8);
    border-radius: 5px;
    letter-spacing: 1px;
    text-align: center;
    white-space: nowrap;
    box-sizing: border-box;
    user-select: none;
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
  }

  // .select.attr-span{
  //   border: 1px solid #2571ef;
  // }
  // .select.text-span{
  //   border: 1px solid #2571ef;
  // }
  .time-select {
    padding: 3px;
    box-sizing: border-box;
    display: flex;
    margin: 0;

    .type-box {
      text-align: center;
      // float: left;
      // height: 36px;
      overflow: hidden;
      background-color: #fff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border: 1px solid #d2d2d2;
      box-sizing: border-box;

      div {
        float: left;
        // padding: 4px 0;
        -webkit-transition: .1s;
        transition: .1s;
        cursor: pointer;
        color: #333;

        &.active {
          background: #5087e4;
          color: #fff;
        }

        span {
          display: inline-block;
          padding: 6px 12px;
          font-size: 14px;
          height: 100%;
          // line-height: 2;
          border-left: 1px solid #e2e2e2;
          float: left;
        }

        &:first-child span {
          border: none;
        }
      }
    }

    .picker {
      // float: left;
      width: 183px;
      margin-left: 10px;
      border-radius: 4px;
      border: 1px solid #d2d2d2;

      &>>>.el-date-editor {
        width: 100%;
        height: 100%;
      }

      &>>>.el-input__inner {
        height: 100%;
        padding-top: 8px;
        padding-bottom: 8px;
        line-height: 100%;
        background-color: inherit;
        color: inherit;
        border: none;
      }

      &>>>.el-input__icon {
        line-height: 100%;
      }

      // &>>>.el-scrollbal:nth-child(2){
      //   display:none;
      // }
    }
  }

  .table-box {
    padding: 3px;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    .table-mask{
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
    }
    .time{
      width: 200px !important;
    }
    .status{
      width: 100px !important;
    }
    .name{
      min-width: 25%;
      width: calc(100% - 25% - 310px) !important;
    }
    .table-title {
      display: flex;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: #3b3b3b;
      font-family: YSBTH;
      font-size: 16px;
      font-weight: 400;
      color: #D9EAF5;
      margin-bottom: 9px;

      &>div {
        width: 25%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .table-item {
      display: flex;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: #2a2a2a;
      font-size: 16px;
      font-weight: 300;
      color: #AFC0D0;
      margin-bottom: 9px;
      font-family: SHL;

      .color-red {
        color: #FF9599;
        background: linear-gradient(0deg, #fd7e83 0%, #fdb2b4 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      &>div {
        width: 25%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:hover {
        background-color: #3b3b3b;
      }
    }
  }

  .progress-bar {
    margin: 3px;

    .bar-title {
      display: flex;
      font-size: 24px;
      font-family: YSBTH;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 24px;
      text-align: left;

      span {
        width: 60%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .f-r {
        width: 40%;
        text-align: right;
        color: #30A0FF;
      }
    }

    .bar-bg {
      background-color: rgba(61, 157, 255, .3);
      height: 12px;
      margin-top: 16px;
      border-style: solid;
      position: relative;

      .bar {
        width: 60%;
        max-width: 100%;
        height: 12px;
        background-color: #3d9dff;
      }

      .bar-line {
        // float: left;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        font-size: 0;
        padding: 0;
        margin: 0;

        div {
          display: inline-block;
          border-left-style: solid;
          height: 100%;
          box-sizing: border-box;
        }

        div:first-child {
          border: none;
        }
      }
    }
  }
  .navmenu-box{
    margin: 3px;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    box-sizing: border-box;
    overflow: auto;
    & .el-menu--horizontal .ment-item{
      display: flex;
    }
  }
  .time-box {
    display: flex;

    .time {
      font-size: 35px;
      color: #FFFFFF;
      font-family: DINE;
      line-height: 35px;
      margin-right: 6px;
      position: relative;
      padding-top: 2px;
    }

    // .time::after {
    //   content: "";
    //   display: inline-block;
    //   position: absolute;
    //   height: 50%;
    //   right: -6px;
    //   border-left: 1px solid #1F2F50;
    //   top: 25%;
    // }

    .day {
      font-size: 16px;
      font-family: SHR;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 18px;
      margin-left: 6px;
    }
  }

  .calendar-box {
    color: #2c3e50;
    overflow: auto;
    margin: 3px;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    user-select: none;
  }

  .calendar-top {
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    .calendar-name {
      max-width: 15%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      cursor: default;
    }

    .data-box {
      max-width: 80%;

      .data-span {
        cursor: default;
        display: inline-block;
        max-width: 45%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }

  .calendar-day {
    text-align: left;
    font-weight: bold;
  }

  .calendar-data {
    line-height: 24px;
    margin-bottom: 2px;
  }

  .grade-box {
    margin: 3px;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    padding: 20px 0 30px;
    box-sizing: border-box;
    position: relative;
  }

  .grade-icon {
    position: absolute;
    top: 2px;
    left: 0%;
    font-size: 16px;
  }

  .grade-bar {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .grade-bar-item {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .grade-bar-item.grade-line::after {
    content: "";
    position: absolute;
    bottom: -8px;
    right: -1px;
    height: 8px;
    display: block;
    border-right: 1px solid #999;
  }

  .grade-data-box{
    display: block;
    position: relative;
  }
  .grade-data-item{
    width: 0;
    position: absolute;
    top: 5px;
  }

  .radio-left {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .radio-right {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  .ranking-box {
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    height: 100%;

    .list-complete-item {
      transition: all .5s;
      height: 38px;
      width: 100%;
      margin-bottom: 8px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-left: 25px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;

      .top {
        width: 100%;
        line-height: 20px;

        .f-l {
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }

        .f-r {
          width: 28%;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .ranking {
          // font-size: 14px;
          font-family: SH;
          font-weight: 400;
          color: #CEE6FC;
        }

        .name {
          // font-size: 16px;
          font-family: SH;
          font-weight: 400;
          color: #AFC0D0;
        }

        .num {
          font-size: 16px;
          font-family: AgencyFB;
          font-weight: 400;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      .slider {
        width: 100%;
        height: 4px;
        background-color: rgba(21, 105, 144, .3);

        .slider-bar {
          height: 100%;
          // background: linear-gradient(90deg, #183c4f 0%, #225279 30%, #6DEFFD 100%);
          position: relative;
          max-width: 100%;
          width: 0;

          .spot {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            right: -2px;
            top: -1px;
          }
        }
      }

      // display: inline-block;
      // margin-right: 10px;
    }

    .blue {
      background-image: url("../../assets/editor-icon/bg-blue.png");

      .num {
        color: #F5B65C;
        background: linear-gradient(0deg, #2378df 0%, #30A0FF 100%);
      }
    }

    .yellow {
      background-image: url("../../assets/editor-icon/bg-yellow.png");

      .slider-bar {
        background: linear-gradient(90deg, #183c4f 0%, #5c5c47 30%, #F5B65C 100%) !important;
      }

      .num {
        color: #F5B65C;
        background: linear-gradient(0deg, #d38e3f 0%, #F5B65C 100%);
      }
    }

    .list-complete-enter,
    .list-complete-leave-to {
      opacity: 0;
      transform: translateY(30px);
    }

    .list-complete-leave-active {
      position: absolute;
    }
  }

  .echarts {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
  }

  .rectangle {
    border: 1px solid #fff;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
  }

  .image {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
  }

  .conduit {
    height: 100%;
    background-size: 100% 100%;
    position: relative;

    .conduit-img {
      height: 100%;
      background-position: 50%;
      background-size: 2.5px 42px;
      background-repeat: repeat-y;
    }

    .conduitX {
      background-repeat: repeat-x;
      background-size: 42px 2.5px;
    }

    .xGif {
      transform: rotate(180deg)
    }

    img {
      position: absolute;
    }

    .left24,
    .left31 {
      top: -8px;
      left: -16px;
    }

    .left27,
    .left29 {
      top: -21px;
      left: -15px;
    }

    .left30 {
      top: -14px;
      left: -15px;
    }

    .right25 {
      top: -8px;
      right: -14px;
    }

    .right26 {
      top: -21px;
      right: -16px;
    }

    .right28 {
      top: -15px;
      right: -14px;
    }

    .right29 {
      top: -21px;
      right: -22px;
    }

    .right31 {
      top: -8px;
      right: -22px;
    }

    .top24 {
      top: -15px;
      left: -7px;
    }

    .top25,
    .top28 {
      top: -15px;
      left: -21px;
    }

    .top30 {
      top: -22px;
      left: -7px;
    }

    .top31 {
      top: -15px;
      left: -14px;
    }

    .bottom26 {
      bottom: -16px;
      left: -20px;
    }

    .bottom27,
    .bottom30 {
      bottom: -16px;
      left: -7px;
    }

    .bottom28 {
      bottom: -16px;
      left: -21px;
    }

    .bottom29 {
      bottom: -16px;
      left: -14px;
    }
  }

  .circular {
    border: 1px solid #fff;
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
    border-radius: 50%;
  }

  .tabs {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    border: 1px solid #fff;
    margin: 3px;
    box-sizing: border-box;
    position: relative;

    .panel-box {
      // position: absolute;
      width: 100%;
      height: 100%;
    }

    .panel-top {
      height: 32px;
      line-height: 32px;
      text-align: center;
      background-color: #2378df;
      position: absolute;
      top: -44px;
      left: 0;
      z-index: 99999;
      width: 100%;

      .close {
        position: absolute;
        right: 0;
        text-align: center;
        font-size: 16px;
        width: 40px;
        height: 100%;
        display: inline-block;
      }

      .state-list {
        background-color: #0A0A0A;
        width: 116px;
        position: absolute;
        left: 50%;
        top: 34px;
        margin-left: -58px;
        text-align: left;

        .state-item {
          font-size: 12px;
          color: #fff;
          padding: 0 10px;
          line-height: 36px;
        }

        .state-item:hover {
          background-color: #2378df;
        }
      }
    }
  }

  .progress {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
    border: 1px solid #aaa;
    border-radius: 3px;
    background-color: #fff;
    overflow: hidden;
    position: relative;

    .bar {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      background-color: #2571ef;
      border-radius: 3px;
    }
  }

  .makeUp {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
  }

  .proup {
    height: calc(100% - 6px);
    width: calc(100% - 6px);
    margin: 3px;
    box-sizing: border-box;
    position: relative;
  }

  .close-icon {
    position: absolute;
    right: -18px;
    top: -18px;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
  }

  .rightMent {
    position: fixed;
    width: 198px;
    background-color: #151515;
    color: #e6e6e6;
    font-size: 12px;
    border-radius: 1px;
    z-index: 999;

    .ment-item {
      float: left;
      text-indent: 18px;
      background-color: #353738;
      line-height: 36px;
      text-align: left;
      width: 100%;
      cursor: pointer;
    }

    .ment-item:hover {
      background-color: #2571ef;
    }
  }

  .line {
    background-color: #fff;
    margin: 1.5px;
    box-sizing: border-box;

    &.vline {
      height: 100%;
      width: 1px;
    }

    &.hline {
      height: 1px;
      width: 100%;
    }
  }
</style>
<style lang="scss">
.table-box{
    .el-table th, .el-table tr{
      background-color: transparent;
    }
    .el-table__header th.is-leaf{
      pointer-events: none;
    }
  }
  .hourpick {
    .el-scrollbar:nth-child(1) {
      width: 100%;
    }

    .el-scrollbar:nth-child(2) {
      display: none;
    }

    .el-scrollbar:nth-child(3) {
      display: none;
    }
  }
  .navmenu-box{

    .el-menu,.el-submenu__title,.el-menu-item,{
      background-color: transparent !important;
      // text-align-last: justify;
    }
    .el-submenu__title i,.el-menu--horizontal.el-menu .el-submenu__title i{
      color:inherit;
    }
    .el-submenu__title,.el-menu-item,.el-menu--horizontal.el-menu .el-menu-item, .el-menu--horizontal.el-menu .el-submenu__title{
      padding-right: 20px;
    }
    .el-menu,.el-menu.el-menu--horizontal{
      border:none !important;
    }
    .el-menu--horizontal.el-menu .el-menu-item, .el-menu--horizontal.el-menu .el-submenu__title{
      // width: 120px;
      min-width: 120px;
    }
    .el-submenu .el-menu-item{
      min-width: 120px;
    }
    .el-menu-item.is-active{
      background-color: #f0f0f0 ;
      font-weight: bold;
      position: relative;
      // &:after{
      //   content: "";
      //   display: block;
      //   position: absolute;
      //   top: 0;
      //   width: 8px;
      //   left: 0;
      //   height: 100%;
      //   background-color: #5087e4;
      // }
    }
    .el-menu-item:not(.is-active) .active-bg{
      background-color: transparent !important;
    }
    .el-submenu__icon-arrow{
      right: 5px !important;
    }
  }
  .navmenu-popper-box{
    text-align: center;
    .el-menu-item.is-active{
      background-color: #f0f0f0 !important;
      font-weight: bold;
      position: relative;
      // &:after{
      //   content: "";
      //   display: block;
      //   position: absolute;
      //   top: 0;
      //   width: 8px;
      //   left: 0;
      //   height: 100%;
      //   background-color: #5087e4;
      // }
    }
    .el-menu,.el-submenu__title,.el-menu-item,{
      // background-color: transparent !important;
      // text-align-last: justify;
    }
    .el-submenu__title,.el-menu-item,.el-menu--horizontal.el-menu .el-menu-item, .el-menu--horizontal.el-menu .el-submenu__title,.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
      padding-right: 20px !important;
    }
    .el-submenu__title i,.el-menu--horizontal.el-menu .el-submenu__title i{
      color:inherit;
    }
    .el-menu-item:not(.is-active) .active-bg{
      background-color: transparent !important;
    }
    .el-submenu__icon-arrow{
      right: 5px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/preview/controlItem.vue